<template>
  <div>
    <div
      id="content"
      class="d-flex scroller"
      @click.stop="clickOnMainContent"
      @click="closeModals($event)"
    >
      <left-panel
        :product="getProduct"
        :active-page="getActivePageIndex"
        :check-modal-open="modalTruthy"
        :key="getActiveObjectId"
        :active-object="getActiveObject"
        :product-address-boxes="getProductAddressBoxes"
        :height="getSelectedPageHeight"
        :width="getSelectedPageWidth"
        :product-size="getProductSize"
        :is-alignment-guide-on="getIsAlignmentGuideOn"
        :is-gray-scale-on="getIsGrayScaleOn"
        :is-product-crop="getIsProductCrop"
        :content-list="getSelectedPageObjectList"
        :product-crop="getProductCrop"
        :is-ruler-on="getIsRulerOn"
        :product-name="getProductName"
        :is-product-size-ratio="isProductSizeRatio"
        :is-inch="getIsSizeInInches"
        :is-open-detail-section="DetailSection.isOpen"
        :bank-type="getProductBankType"
        class="flex-left-panel"
        @OpenDetailSection="openDetailSection"/>
      <canvas-panel
        :product="getProduct"
        :active-object="getActiveObject"
        :key="getCanvasPanelKey"
        :is-alignment-guide-on="getIsAlignmentGuideOn"
        :is-gray-scale-on="getIsGrayScaleOn"
        :height="getSelectedPageHeight"
        :width="getSelectedPageWidth"
        :base-image="getSelectedPageBaseImage"
        :content-list="getSelectedPageObjectList"
        :active-page="getActivePageIndex"
        :product-pages-length="getProductPagesLength"
        :product-crop="getProductCrop"
        :is-ruler-on="getIsRulerOn"
        :product-scale="getProductScale"
        class="flex-center-panel d-flex flex-column bg-light-gray position-relative overflow-hidden   "/>
      <!--        :base-image="getBaseImage"
            TODO: Remove getBaseImage-->
      <right-panel
        :content-list="getSelectedPageObjectList"
        :active-object="getActiveObject"
        :product="product"
        :active-page="getActivePageIndex"
        class="flex-right-panel scroller"/>
    </div>
    <div v-show="isLoaderVisible === true">
      <div class="loader-styling position-absolute h-100 w-100 d-flex flex-column justify-content-center align-items-center align-content-center set-z-index">
        <div class="loader">
          <img
            src="loader/circular_loader.svg"
            height="256"
            width="256"
            alt="Loader Image">
        </div>
        <div>
          <h2>Loading...</h2>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-plusplus */
import LeftSection from '@/components/LeftSection/LeftSection';
import RightPanel from '@/components/RightPanel/RightPanel';
import CanvasPanel from '@/components/CanvasPanel/CanvasPanel';
import Text from '@/components/DesignObjects/TextObject';
import Image from '@/components/DesignObjects/ImageObject';
import Background from '@/components/DesignObjects/BackgroundObject';
import EventBus from '@/EventBus';
import { v4 as uuidv4 } from 'uuid';
import {
  hexToRgb,
  helperFunctionToReverseSortByObjectKey,
} from '@/components/Helper';
import _ from 'lodash';
import undoRedoManager from '@/components/MainContent/mixins/undoRedoManager';
import saveProductManager from '@/components/MainContent/mixins/saveProductManager';
import axios from 'axios';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';
import FontFaceObserver from 'fontfaceobserver';

export default {
  name:       'MainContent',
  components: {
    'left-panel':   LeftSection,
    'canvas-panel': CanvasPanel,
    'right-panel':  RightPanel,
  },
  mixins: [undoRedoManager, saveProductManager],
  data() {
    return {
      checkModal:          false,
      value:               0,
      modalTruthy:         false,
      product:             { pages: [], transitions: [] },
      ProductAddressBoxes: [],
      ProductHousingLogos: [],
      ProductNcuaLogos:    [],
      ProductFdicLogos:    [],
      activePage:          -1,
      selectedPage:        { objectList: [], width: 577, height: 640 },
      activeObject:        null,
      maxPDFSortOrder:     0,
      loadProductXML:      null,
      isLoaderVisible:     false,
      productPagesLength:  0,
      isRulerOn:           false,
      DetailSection:       {
        isOpen: false,
        Id:     null,
      },
      isProductSizeRatio:   true,
      defaultProductWidth:  null,
      defaultProductHeight: null,
      defaultProductName:   null,
      jsonFile:             '{"Orientation":"Horizontal","SvgShapes":"","TriviaQuestions":null,"PageWidths":{"double":1200},"PageHeights":{"double":628},"Id":"393dddd6-5b86-495d-b161-9ee8eee34a4c","BankType":"Bank","Name":"SVG%20Test","CsvFilePath":null,"Size":"(1200x628) ","IsInch":false,"IsDigitalMedia":true,"ConvertToBlackAndWhite":true,"AllowFontChanging":true,"AllowProductRename":true,"AllowSizeChange":true,"AllowCropping":false,"CropOnOff":false,"AllowFieldResize":true,"AllowFieldMove":true,"AllowFieldRotate":true,"AllowAddingTextField":true,"AllowAddingBackgroundField":true,"IsRssProduct":false,"AllowAddingImageField":true,"WidthCrop":1200,"HeightCrop":628,"XCrop":0,"YCrop":0,"BaseImage":"https://www.bankmarketingcenter.com/temp/convertedimages/c5a6f445-a09f-4cb9-82c2-4c6b603a0baafb.base048False.png\\\\n","IsGrayscale":false,"pages":[{"objectList":[{"AllowMove":"true","AllowResize":"true","AllowRotate":"true","ColorSystem":"CMYK","DefaultColor":"cmyk(0% 0% 0% 0%)","Height":106,"Id":"4532e8c0-b725-11ec-8906-3f405b620829","IsHtml":true,"IsVisible":true,"Name":"Body","PageNo":"1","PdfSortOrder":4,"RotateDegree":0,"RotateX":0,"RotateY":0,"SortOrder":4,"Value":"abc","modifiedHtml":"qabc","Width":160,"X":226,"Y":381,"elementIndex":0,"editor":null,"locked":false,"type":"text","scaleX":1,"scaleY":1,"isEditorEnable":false,"isSelected":false,"isEditableForRightPanel":false,"fontFamily":"Arial","VerticalAlign":"Middle","fontSize":16,"lineSpacing":1.2,"color":"#000000","isBold":false,"isItalic":false,"isUnderline":false,"isJustifyCenter":false,"isJustifyLeft":true,"isJustifyRight":false,"verticalAlign":"top","isJustify":false,"isBulletList":false,"isNumberList":false,"isSubScript":false,"isSupperScript":false,"valuesForLeftPanel":{"fontFamily":"Arial","fontSize":16,"lineSpacing":1.2,"color":"rgb(0, 0, 0)","isBold":false,"isItalic":true,"isUnderline":false,"isJustifyCenter":false,"isJustifyLeft":true,"isJustifyRight":false,"isJustify":false,"isBulletList":false,"isNumberList":false,"isSubScript":false,"isSuperScript":false},"lineHeight":1.2,"objectId":"4532e8c0-b725-11ec-8906-3f405b620829","pageNo":0}],"width":612,"height":792,"baseImage":"https://www.bankmarketingcenter.com/temp/convertedimages/c5a6f445-a09f-4cb9-82c2-4c6b603a0baafb.base048False.png"}],"scaleX":1,"scaleY":1,"isShowCrop":false,"isAlignmentGuideOn":false,"isEditedByNewEditor":true,"pdfUrl":"https://pdf-processing.bankmarketingcenter.com/pdf/designs/design-szRqKHdMWf-scaled.pdf"}',
    }; // TODO: Muaaz kindly add this in config file
  },

  computed: {
    getProductScale() {
      return [this.product.scaleX, this.product.scaleY];
    },
    getProductBankType() {
      if (!this.product) { return ''; }
      return this.product.BankType;
    },
    getIsSizeInInches() {
      return this.product.IsInch;
    },
    getProductCrop() {
      if (this.activePage < 0) {
        return {};
      }
      const {
        AllowCropping, XCrop, YCrop, WidthCrop, HeightCrop,
      } = this.product;
      return {
        AllowCropping, XCrop, YCrop, WidthCrop, HeightCrop,
      };
    },

    /**
     * CHANGES: Always show Product actual width and ignore crop mark width
     * Changed this section to ignore crop marks size when shwoing
     * product width and height. Alternatively, to incorporate crop marks
     * check If crop marks i.e. product.AllowCropping = true then return this.product.WidthCrop
     * else return getSelectedPageWidth
     */

    getCropWidth() {
      if (this.activePage < 0) {
        return 577;
      }
      return Math.round(parseFloat(this.product.XCrop)) > 0 ? Math.round(parseFloat(this.product.WidthCrop)) : this.getSelectedPageWidth;
    },
    getCropHeight() {
      if (this.activePage < 0) {
        return 640;
      }
      return Math.round(parseFloat(this.product.YCrop)) > 0 ? Math.round(parseFloat(this.product.HeightCrop)) : this.getSelectedPageHeight;
    },
    getIsAlignmentGuideOn() {
      return this.product.isAlignmentGuideOn;
    },
    getIsGrayScaleOn() {
      return this.product.IsGrayscale;
    },
    getProductSize() {
      return this.product.IsInch ? this.getProductSizeInches : this.getProductSizePixel;
      // return {width: , height: }
    },
    getProductName() {
      return this.product.Name;
    },
    getProductSizePixel() {
      return {
        width:        this.getCropWidth,
        height:       this.getCropHeight,
        selectedUnit: 'Pixels',
        otherUnit:    'Inches',
      };
    },
    getProductSizeInches() {
      const height = this.getCropHeight;
      const width  = this.getCropWidth;
      // this.product.AllowCropping && (width = this.getCropWidth);
      // this.product.AllowCropping && (height = this.getCropHeight);

      const inchesWidth  = width * 0.013888888888888888;
      const inchesHeight = height * 0.013888888888888888;
      return {
        width:        inchesWidth.toFixed(2),
        height:       inchesHeight.toFixed(2),
        selectedUnit: 'Inches',
        otherUnit:    'Pixels',
      };
    },

    getIsProductCrop() {
      return { allowCrop: this.product.AllowCropping, isShowCrop: this.product.isShowCrop };
    },
    getIsRulerOn() {
      return this.isRulerOn;
    },
    getProductPagesLength() {
      return this.productPagesLength;
    },
    getProductAddressBoxes() {
      return this.ProductAddressBoxes;
    },
    getEqualHousingLogos() {
      return this.ProductHousingLogos;
    },
    getNcuaLogos() {
      return this.ProductNcuaLogos;
    },
    getFdicLogos() {
      return this.ProductFdicLogos;
    },
    getActiveObjectId() {
      if (this.activeObject != null) {
        return this.activeObject.Id;
      }
      return '';
    },
    getSelectedPage() {
      return this.selectedPage;
    },
    getCanvasPanelKey() {
      return `${uuidv4()}-${this.getSelectedPageWidth}-${this.getSelectedPageHeight}`;
    },
    getLeftPanelKey() {
      console.log('new left panel key');
      return `${uuidv4()}-${this.getSelectedPageWidth}-${this.getSelectedPageHeight}`;
    },
    getActiveObject() {
      this.activeObject && this.closeDetailsection();
      return this.activeObject;
    },
    getSelectedPageObjectList() {
      return this.activePage > -1 ? this.product.pages[this.activePage].objectList : [];
    },
    getSelectedPageWidth() {
      if (this.activePage > -1) { console.log('Seleceted Page width is ', this.product.pages[this.activePage].width); }
      return this.activePage > -1 ? this.product.pages[this.activePage].width : 0;
    },
    getSelectedPageHeight() {
      return this.activePage > -1 ? this.product.pages[this.activePage].height : 0;
    },
    getSelectedPageBaseImage() {
      return this.activePage > -1 ? this.product.pages[this.activePage].baseImage : '';
    },
    getActivePageIndex() {
      return this.activePage;
    },
    getOpacityValues() {
      return this.value;
    },
    getProduct() {
      return this.activePage > -1 ? this.product : null;
    },
  },
  watch: {
    getActivePageIndex: {
      handler() {
        EventBus.$emit('updateProductActivePageIndex', this.getActivePageIndex);
        EventBus.$emit('changeUndoRedoRestButtonOnPageChange');
      },
    },
    getSelectedPageObjectList: {
      deep: true,
      handler() {
        EventBus.$emit('updateProductInHeader', this.getSelectedPageObjectList);
      },
    },
    getSelectedPageHeight: {
      deep: true,
      handler() {
        EventBus.$emit('updateSelectedPageHeightInHeader', this.getSelectedPageHeight);
      },
    },
    getSelectedPageWidth: {
      deep: true,
      handler() {
        EventBus.$emit('updateSelectedPageWidthInHeader', this.getSelectedPageWidth);
      },
    },
    getProductCrop: {
      deep: true,
      handler() {
        EventBus.$emit('updateProductCropMark', this.getProductCrop);
      },
    },
    product: {
      deep: true,
      handler(newProduct) {
        EventBus.$emit('onUpdateProduct', this.getProduct);
      },
    },
  },
  mounted() {
    this.loadSvgShapeCategories();
    this.loadSvgShapes();
    this.getFavouriteSizes();
    const urlSearchPart      = window.location.search;
    const newUrlSearchParams = new URLSearchParams(urlSearchPart);

    if (!newUrlSearchParams.has('productId') && !newUrlSearchParams.has('orderitem_id')) {
      // this.parseProductFromXML(this.$xml2);
      // this.loadProductFromJson(this.jsonFile)

    }

    // :Event Bus on listener
    EventBus.$on('selectedProductOption', this.selectedProductRecieved);
    EventBus.$on('updateProductPagesOrder', this.updateProductPagesOrder);
    EventBus.$on(ApplicationEventTypes.ProductLoadingEvents.UPDATE_HTML_AFTER_ENABLE_EDITOR, this.onUpdateHTML);
    EventBus.$on(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.onUpdateContentListIndexOnLayerSwap);
    EventBus.$on(ApplicationEventTypes.UndoRedoEvents.ADDED, this.onAddIntoPageWiseUndoRedoArray);
    EventBus.$on(ApplicationEventTypes.UndoRedoEvents.PRODUCT_UPDATED, this.onUpdateProductByPageWiseUndoRedo);
    EventBus.$on(ApplicationEventTypes.UndoRedoEvents.RESET_PAGE_UNDO_REDO, this.resetSpecificUndoRedoArray);
    EventBus.$on(ApplicationEventTypes.ProductPageEvents.PAGE_CHANGE, this.onChangeProductPage);
    EventBus.$on(ApplicationEventTypes.ProductPageEvents.PAGE_DELETE, this.onDeleteProductPage);
    EventBus.$on(ApplicationEventTypes.ProductPageEvents.PAGE_DUPLICATE, this.onDuplicateProductPage);
    EventBus.$on(ApplicationEventTypes.ProductPageEvents.PAGE_CREATE, this.onCreateNewProductPage);
    EventBus.$on(ApplicationEventTypes.LeftPanelEvents.CHANGE_PRODUCT_SIZE_FROM_DROPDOWN, this.changeProductSizeFromDropDown);
    EventBus.$on('changeFontStyle', this.updateStyle);
    EventBus.$on('updateObjectAfterCrop', this.onUpdateObjectAfterCrop);
    EventBus.$on('onObjectAdding', this.onObjectAdding);
    EventBus.$on(ApplicationEventTypes.ObjectSelectionEvents.SELECTED, this.onObjectSelected);
    EventBus.$on(ApplicationEventTypes.ObjectSelectionEvents.CLEARED, this.onObjectSelectedCleared);
    EventBus.$on('toggleBulletList', this.changeToggleBulletList);
    EventBus.$on('toggleNumberList', this.changeToggleNumberList);
    EventBus.$on('toggleSupperScriptList', this.changetoggleSupperScriptList);
    EventBus.$on('toggleSubScriptList', this.changetoggleSubScriptList);
    EventBus.$on(ApplicationEventTypes.LeftPanelEvents.RESET_PRODUCT_SIZE, this.setDefaultProduct);

    EventBus.$on('saveProduct', this.onSaveProduct);
    EventBus.$on('updatePageContent', this.updatePageContent);
    EventBus.$on('showHideLoader', this.updateIsLoaderVisible);
    EventBus.$on('pushValues', this.onReceivePushedValue);
    EventBus.$on(ApplicationEventTypes.LeftPanelEvents.RESET, this.deSelectActiveObject);
    EventBus.$on('changeProductAllowCropping', this.changeProductAllowCropping);
    EventBus.$on('changeAllowAlignmentGuides', this.onChangeAllowAlignmentGuides);
    EventBus.$on('changeProductSizeAfterResize', this.onChangeProductSizeAfterResize);
    EventBus.$on('changeProductName', this.onChangeProductName);
    EventBus.$on('toggleProductSizeRatioFlag', this.onToggleProductSizeRatioFlag);
    EventBus.$on('toggleGrayScale', this.onToggleGrayScale);
    EventBus.$on('toggleRuler', this.onToggleRuler);
    EventBus.$on('updateProductSize', this.changeProductSize);
    EventBus.$on('updateProductColor', this.updateProductColorList);
    EventBus.$on('ReplaceHighResResources', this.onReplaceHighResResources);
    EventBus.$on('loadProductFromJson', this.loadProductFromJson);
    EventBus.$on('UpdateTextObjectValue', this.updateTextObjectValue);
    EventBus.$on('deleteFavouriteSize', this.deleteFavouriteSize);
    EventBus.$on('addFavouriteSizeToAPI', this.addFavouriteSizeToAPI);
    EventBus.$on(ApplicationEventTypes.TransitionEvents.ADD_TRANSITION, this.applyPageTransition);
    EventBus.$on(ApplicationEventTypes.TransitionEvents.UPDATE_TRANSITION, this.updatePagesTransition);
    EventBus.$on(ApplicationEventTypes.ProductPageEvents.PAGE_DURATION_UPDATE, this.updateProductPageDuration);
    EventBus.$on(ApplicationEventTypes.ProductPageEvents.ACTIVE_PAGE_DURATION_UPDATE, this.updateActivePageDuration);
    EventBus.$on(ApplicationEventTypes.ProductPageEvents.UPDATE_PRODUCT_TRANSITION_OBJECT, this.updateProductTransitionObjects);
    EventBus.$on(ApplicationEventTypes.ProductPageEvents.UPDATE_PAGE_UNDO_REDO_OBJ, this.updatePageUndoRedoObject);
    EventBus.$on(ApplicationEventTypes.Audio.ADD_NEW_AUDIO, this.AddNewAudio);
    EventBus.$on(ApplicationEventTypes.Video.ToggleVideoMood, this.toggleVideoMood);
    EventBus.$on(ApplicationEventTypes.Video.UPDATE_VIDEO_URL_ATTR_IN_PRODUCT, this.updateVideoAttrInProduct);
    EventBus.$on(ApplicationEventTypes.Video.UPDATE_VIDEO_WATERMARK_URL_ATTR_IN_PRODUCT, this.updateVideoWatermarkAttrInProduct);
    EventBus.$on(ApplicationEventTypes.Video.UPDATE_VIDEO_GIF_URL_ATTR_IN_PRODUCT, this.updateVideoGifAttrInProduct);
    EventBus.$on(ApplicationEventTypes.ProductPageEvents.PRODUCT_PAGES_SHOULD_BE_SAME, this.allPagesShouldBeSame);
    EventBus.$on(ApplicationEventTypes.ProductSave.SAVE_PRODUCT_AS_TEMPLATE, this.saveProductAsTemplate);
    EventBus.$on(ApplicationEventTypes.ImageObjectEvents.SELECTED_VIDEO_FOR_LEFT_PANEL, this.addingAlternativeVideo);
    EventBus.$on(ApplicationEventTypes.ImageObjectEvents.REPLACE_VIDEO, this.replaceCanvasVideo);
    EventBus.$on('replaceBgRemoverImageUrl', this.replaceBgRemoverImageUrl);
  },
  beforeDestroy() {
    EventBus.$off('updateProductPagesOrder', this.updateProductPagesOrder);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.CHANGE_PRODUCT_SIZE_FROM_DROPDOWN, this.changeProductSizeFromDropDown);
    EventBus.$off('updateObjectAfterCrop');
    EventBus.$off('toggleProductSizeRatioFlag', this.onToggleProductSizeRatioFlag);
    EventBus.$off(ApplicationEventTypes.ProductLoadingEvents.UPDATE_HTML_AFTER_ENABLE_EDITOR, this.onUpdateHTML);
    EventBus.$off(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.onUpdateContentListIndexOnLayerSwap);
    EventBus.$off(ApplicationEventTypes.UndoRedoEvents.ADDED, this.onAddIntoPageWiseUndoRedoArray);
    EventBus.$off(ApplicationEventTypes.UndoRedoEvents.PRODUCT_UPDATED, this.onUpdateProductByPageWiseUndoRedo);
    EventBus.$off(ApplicationEventTypes.ProductPageEvents.PAGE_CHANGE, this.onChangeProductPage);
    EventBus.$off(ApplicationEventTypes.ProductPageEvents.PAGE_DELETE, this.onDeleteProductPage);
    EventBus.$off(ApplicationEventTypes.ProductPageEvents.PAGE_DUPLICATE, this.onDuplicateProductPage);
    EventBus.$off(ApplicationEventTypes.ProductPageEvents.PAGE_CREATE, this.onCreateNewProductPage);
    EventBus.$off('changeFontStyle', this.updateStyle);
    EventBus.$off('changeAllowAlignmentGuides', this.onChangeAllowAlignmentGuides);
    EventBus.$off('toggleGrayScale', this.onToggleGrayScale);
    EventBus.$off('changeProductSize', this.changeProductSize);
    EventBus.$off('changeProductSizeAfterResize', this.onChangeProductSizeAfterResize);
    EventBus.$off('changeProductName', this.onChangeProductName);
    EventBus.$off('onObjectAdding', this.onObjectAdding);
    EventBus.$off(ApplicationEventTypes.ObjectSelectionEvents.SELECTED, this.onObjectSelected);
    EventBus.$off(ApplicationEventTypes.ObjectSelectionEvents.CLEARED, this.onObjectSelectedCleared);
    EventBus.$off('toggleBulletList', this.changeToggleBulletList);
    EventBus.$off('toggleNumberList', this.changeToggleNumberList);
    EventBus.$off('toggleSupperScriptList', this.changetoggleSupperScriptList);
    EventBus.$off('toggleSubScriptList', this.changetoggleSubScriptList);
    EventBus.$off('selectedProductOption', this.selectedProductRecieved);
    EventBus.$off('saveProduct', this.onSaveProduct);
    EventBus.$off('updatePageContent', this.updatePageContent);
    EventBus.$off('showHideLoader', this.updateIsLoaderVisible);
    EventBus.$off('pushValues', this.onReceivePushedValue);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.RESET, this.deSelectActiveObject);
    EventBus.$off('changeProductAllowCropping', this.changeProductAllowCropping);
    EventBus.$off('updateProductSize');
    EventBus.$off('toggleRuler');
    EventBus.$off('updateProductColor', this.updateProductColorList);
    EventBus.$off('ReplaceHighResResources', this.onReplaceHighResResources);
    EventBus.$off('loadProductFromJson', this.loadProductFromJson);
    EventBus.$off('UpdateTextObjectValue', this.updateTextObjectValue);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.RESET_PRODUCT_SIZE);
    EventBus.$off(ApplicationEventTypes.TransitionEvents.ADD_TRANSITION, this.applyPageTransition);
    EventBus.$off(ApplicationEventTypes.TransitionEvents.UPDATE_TRANSITION, this.updatePagesTransition);
    EventBus.$off(ApplicationEventTypes.ProductPageEvents.PAGE_DURATION_UPDATE, this.updateProductPageDuration);
    EventBus.$off(ApplicationEventTypes.ProductPageEvents.ACTIVE_PAGE_DURATION_UPDATE, this.updateActivePageDuration);
    EventBus.$off(ApplicationEventTypes.ProductPageEvents.UPDATE_PRODUCT_TRANSITION_OBJECT, this.updateProductTransitionObjects);
    EventBus.$off(ApplicationEventTypes.Audio.ADD_NEW_AUDIO, this.AddNewAudio);
    EventBus.$off(ApplicationEventTypes.Video.ToggleVideoMood, this.toggleVideoMood);
    EventBus.$off(ApplicationEventTypes.Video.UPDATE_VIDEO_URL_ATTR_IN_PRODUCT, this.updateVideoAttrInProduct);
    EventBus.$off(ApplicationEventTypes.Video.UPDATE_VIDEO_WATERMARK_URL_ATTR_IN_PRODUCT, this.updateVideoWatermarkAttrInProduct);
    EventBus.$off(ApplicationEventTypes.Video.UPDATE_VIDEO_GIF_URL_ATTR_IN_PRODUCT, this.updateVideoGifAttrInProduct);
    EventBus.$off(ApplicationEventTypes.ProductPageEvents.PRODUCT_PAGES_SHOULD_BE_SAME, this.allPagesShouldBeSame);
    EventBus.$off(ApplicationEventTypes.ProductSave.SAVE_PRODUCT_AS_TEMPLATE, this.saveProductAsTemplate);
    EventBus.$off(ApplicationEventTypes.ImageObjectEvents.SELECTED_VIDEO_FOR_LEFT_PANEL, this.addingAlternativeVideo);
    EventBus.$off(ApplicationEventTypes.ImageObjectEvents.REPLACE_VIDEO, this.replaceCanvasVideo);
    EventBus.$off('replaceBgRemoverImageUrl', this.replaceBgRemoverImageUrl);
  },
  beforeUpdate() {
    const urlSearchPart      = window.location.search;
    const newUrlSearchParams = new URLSearchParams(urlSearchPart);
    if (!newUrlSearchParams.has('productId') && !newUrlSearchParams.has('orderitem_id')) {
      this.sortContentListArray();
    }
  },
  methods: {
    replaceBgRemoverImageUrl(src) {
      if (this.activeObject != null) {
        const objectList = _.cloneDeep(this.product.pages[this.activePage].objectList);
        const selectedObject = objectList.find(elem => elem.Id == this.activeObject.Id);

        if (selectedObject.ImageType === 'Image') {
          selectedObject.HighResPath = src;
          selectedObject.isBackgroundRemoved = true;
          selectedObject.DefaultImageUrl = src;
          EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED);
          EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, objectList);
          EventBus.$emit('addIntoPageWiseUndoRedoArray', 'Replace image');
        }
      }
    },
    replaceCanvasVideo(videoObj) {
      if (this.activeObject != null) {
        const objectList     = _.cloneDeep(this.product.pages[this.activePage].objectList);
        const selectedObject = objectList.find(elem => elem.Id == this.activeObject.Id);

        selectedObject.Name         = videoObj.Name;
        selectedObject.videoDetails = {
          VideoSourceUrl: videoObj.LowResUrl,
          duration:       videoObj.Duration,
          endTime:        videoObj.Duration,
          startTime:      0,
          width:          videoObj.Width,
          height:         videoObj.Height,
          mimeType:       'video/mp4',
          audio:          (!videoObj.AudioUrl || videoObj.AudioUrl.length < 10) ? 'https://video-processing.bankmarketingcenter.com/ffmpeg-video/audio-6ybTJmVkIN.mp3' : videoObj.AudioUrl,
          videoHighRes:   videoObj.HighResUrl,
        };
        this.activeObject           = _.cloneDeep(selectedObject);
        EventBus.$emit('SetPageVideoLength', videoObj.Duration);
        EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, objectList);
        EventBus.$emit('addIntoPageWiseUndoRedoArray', 'Replace Video');
      }
    },
    addingAlternativeVideo(data) {
      const objectList     = _.cloneDeep(this.product.pages[this.activePage].objectList);
      const selectedObject = objectList.find(elem => elem.Id == this.activeObject.Id);
      if (!selectedObject.AlternativeVideoUrlsResVersion) {
        selectedObject.AlternativeVideoUrlsResVersion = [];
      }
      selectedObject.AlternativeVideoUrlsResVersion.push(data);

      this.activeObject = selectedObject;
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, objectList);

      this.$store.commit('setIsVideoModel', false);
      this.$store.commit('setDisplayAddVideoModal', false);
    },
    updateProductPagesOrder(pages) {
      const cloneProduct = _.cloneDeep(this.product);
      cloneProduct.pages = pages;

      this.product = cloneProduct;
    },
    async AllProductPagesShouldHaveSameDimensions(data) {
      if ((data.newWidth && parseInt(data.newWidth, 10) < 1) || (data.newHeight && parseInt(data.newHeight, 10) < 1)) { return; }

      const cloneProduct = _.cloneDeep(this.product);

      const oldWidth  = parseFloat(this.getCropWidth);
      const oldHeight = parseFloat(this.getCropHeight);

      const newWidth  = data.newWidth;
      const newHeight = data.newHeight;
      const isCropX   = Math.round(parseFloat(this.product.XCrop)) > 0;
      const isCropY   = Math.round(parseFloat(this.product.YCrop)) > 0;
      this.product.pages.length > 1 && (EventBus.$emit('showHideLoader', true));


      const keepActivePage = this.activePage;
      for (let y = 1; y < cloneProduct.pages.length; y++) {
        this.activePage   = y;
        const oldWidth    = parseFloat(this.getCropWidth);
        const oldHeight   = parseFloat(this.getCropHeight);
        const widthRatio  = parseFloat(newWidth / oldWidth);
        const heightRatio = parseFloat(newHeight / oldHeight);

        cloneProduct.pages[y].width  = isCropX ? newWidth + (cloneProduct.XCrop * 2) : newWidth;
        cloneProduct.pages[y].height = isCropY ? newHeight + (cloneProduct.YCrop * 2) : newHeight;

        for (let i = 0; i < cloneProduct.pages[y].objectList.length; i++) {
          if (cloneProduct.pages[y].objectList[i].type === 'image') {
            cloneProduct.pages[y].objectList[i].X *= widthRatio;
            cloneProduct.pages[y].objectList[i].Y *= heightRatio;
            if (cloneProduct.pages[y].objectList[i].Name === 'z-border') {
              cloneProduct.pages[y].objectList[i].scaleX *= widthRatio;
              cloneProduct.pages[y].objectList[i].scaleY *= heightRatio;
            } else {
              cloneProduct.pages[y].objectList[i].Width  *= widthRatio;
              cloneProduct.pages[y].objectList[i].Height *= heightRatio;
            }
            if (cloneProduct.pages[y].objectList[i].ImageType === 'SVGImage') {
              const shapeObject                  = cloneProduct.pages[y].objectList[i];
              shapeObject.SvgProperty.svgScaleX *= widthRatio;
              shapeObject.SvgProperty.svgScaleY *= heightRatio;
              const isTransformStyle             = shapeObject.SvgProperty.content.includes(`style="transform-origin: left top; transform: ${shapeObject.SvgProperty.style};"`);
              const isTransformStyleWith0Px      = shapeObject.SvgProperty.content.includes(`style="transform-origin: left top 0px; transform: ${shapeObject.SvgProperty.style};"`);
              if (isTransformStyle || isTransformStyleWith0Px) {
                if (isTransformStyleWith0Px) {
                  shapeObject.SvgProperty.content = shapeObject.SvgProperty.content.replace(`style="transform-origin: left top 0px; transform: ${shapeObject.SvgProperty.style};"`, `style="transform-origin: left top; transform: scale(${shapeObject.SvgProperty.svgScaleX}, ${shapeObject.SvgProperty.svgScaleY});"`);
                } else {
                  shapeObject.SvgProperty.content = shapeObject.SvgProperty.content.replace(`style="transform-origin: left top; transform: ${shapeObject.SvgProperty.style};"`, `style="transform-origin: left top; transform: scale(${shapeObject.SvgProperty.svgScaleX}, ${shapeObject.SvgProperty.svgScaleY});"`);
                }
                shapeObject.SvgProperty.style = `scale(${shapeObject.SvgProperty.svgScaleX}, ${shapeObject.SvgProperty.svgScaleY})`;
              }
            }
          }
          if (cloneProduct.pages[y].objectList[i].type === 'shape') {
            cloneProduct.pages[y].objectList[i].X      *= widthRatio;
            cloneProduct.pages[y].objectList[i].Y      *= heightRatio;
            cloneProduct.pages[y].objectList[i].Width  *= widthRatio;
            cloneProduct.pages[y].objectList[i].Height *= heightRatio;
            const shapeObject                           = cloneProduct.pages[y].objectList[i];
            shapeObject.svgScaleX                      *= widthRatio;
            shapeObject.svgScaleY                      *= heightRatio;
            if (document.getElementById(shapeObject.Id) && document.getElementById(shapeObject.Id).querySelector('svg') && (shapeObject.shapeType === 'polygon' || shapeObject.shapeType === 'ellipses')) {
              const shapeElement = document.getElementById(shapeObject.Id).querySelector('svg');
              shapeObject.Width  = parseFloat(shapeElement.getAttribute('width')) * shapeObject.svgScaleX;
              shapeObject.Height = parseFloat(shapeElement.getAttribute('height')) * shapeObject.svgScaleY;
            }
          }
          if (cloneProduct.pages[y].objectList[i].type === 'text') {
            if (widthRatio == heightRatio) {
              const oldOffsetWidth  = (cloneProduct.pages[y].objectList[i].Width * cloneProduct.pages[y].objectList[i].scaleX - cloneProduct.pages[y].objectList[i].Width) / 2;
              const oldOffsetHeight = (cloneProduct.pages[y].objectList[i].Height * cloneProduct.pages[y].objectList[i].scaleY - cloneProduct.pages[y].objectList[i].Height) / 2;

              cloneProduct.pages[y].objectList[i].scaleY *= widthRatio;
              cloneProduct.pages[y].objectList[i].scaleX *= widthRatio;

              cloneProduct.pages[y].objectList[i].X = (cloneProduct.pages[y].objectList[i].X - oldOffsetWidth) * widthRatio;
              cloneProduct.pages[y].objectList[i].Y = (cloneProduct.pages[y].objectList[i].Y - oldOffsetHeight) * heightRatio;

              const newOffsetWidth  = (cloneProduct.pages[y].objectList[i].Width * cloneProduct.pages[y].objectList[i].scaleX - cloneProduct.pages[y].objectList[i].Width) / 2;
              const newOffsetHeight = (cloneProduct.pages[y].objectList[i].Height * cloneProduct.pages[y].objectList[i].scaleY - cloneProduct.pages[y].objectList[i].Height) / 2;

              cloneProduct.pages[y].objectList[i].X += newOffsetWidth;
              cloneProduct.pages[y].objectList[i].Y += newOffsetHeight;
            } else {
              cloneProduct.pages[y].objectList[i].X      *= widthRatio;
              cloneProduct.pages[y].objectList[i].Y      *= heightRatio;
              cloneProduct.pages[y].objectList[i].Width  *= widthRatio;
              cloneProduct.pages[y].objectList[i].Height *= heightRatio;

              let element       = document.createElement('div');
              element.innerHTML = cloneProduct.pages[y].objectList[i].Value;
              element           = element.cloneNode(true);
              if (element) {
                const childList    = element.querySelectorAll('SPAN , FONT, li , ul, div');
                const ratioForText = parseFloat((widthRatio * heightRatio));
                if (childList.length) {
                  for (const current of childList) {
                    if (current.getAttribute('style') && current.getAttribute('style').indexOf('font-size:') !== -1) {
                      current.style.fontSize = `${parseFloat(parseFloat(current.style.fontSize) * ratioForText)}px`;
                    }
                  }
                }
                cloneProduct.pages[y].objectList[i].fontSize                    = parseFloat(cloneProduct.pages[y].objectList[i].fontSize) * ratioForText;
                cloneProduct.pages[y].objectList[i].valuesForLeftPanel.fontSize = cloneProduct.pages[y].objectList[i].fontSize;
                cloneProduct.pages[y].objectList[i].Value                       = element.outerHTML;
                cloneProduct.pages[y].objectList[i].modifiedHtml                = element.outerHTML;
              }
            }
          }
        }


        if (this.product.pages.length > 1) {
          this.product.pages[y] = cloneProduct.pages[y];
          await new Promise(r => setTimeout(r, 1000));
        }
      }
      this.$nextTick(() => {
        EventBus.$emit('showHideLoader', false);
        this.activePage = keepActivePage;
        this.product    = cloneProduct;
        this.$store.commit('activeProduct/updateIsVideoMoodOn', true);
        EventBus.$emit(ApplicationEventTypes.Video.ToggleVideoMood, true);
      });
    },
    allPagesShouldBeSame() {
      const tempProduct = _.cloneDeep(this.product);
      const newHeight   = tempProduct.pages[0].height;
      const newWidth    = tempProduct.pages[0].width;
      const data        = {
        newWidth,
        newHeight,
      };
      console.log('Data ', data);
      this.AllProductPagesShouldHaveSameDimensions(data);
    },
    updateVideoAttrInProduct(videoUrl) {
      this.product.videoUrl = videoUrl;
      delete this.product.pdfUrl;
    },
    updateVideoGifAttrInProduct(gifUrl) {
      this.product.gifUrl = gifUrl;
    },
    updateVideoWatermarkAttrInProduct(videoWatermarkUrl) {
      this.product.watermarkVideoUrl = videoWatermarkUrl;
    },
    toggleVideoMood(value) {
      const tempProduct         = _.cloneDeep(this.product);
      tempProduct.isVideo       = value;
      tempProduct.isVideoEditor = value;
      console.log('tempProduct');
      console.log(tempProduct);
      tempProduct.pages.forEach((page, index) => {
        if (!page.animation) {
          tempProduct.pages[index].animation = {
            speed:         1,
            style:         'pageAnimationNone',
            startTime:     0.0,
            duration:      5.0,
            onEnter:       false,
            onExit:        false,
            timeLineWidth: 140,
          };
        }
      });
      this.product = tempProduct;
    },
    AddNewAudio(audioDetails) {
      const cloneProduct        = _.cloneDeep(this.product);
      cloneProduct.audioDetails = audioDetails;
      this.product              = cloneProduct;
    },
    updatePageUndoRedoObject() { // unused function
      const self = this;
      this.product.pages.forEach((page, i) => {
        page.objectList.forEach((object, j) => {
          if (object.type == 'pagedetails') {
            self.product.pages[i].objectList[j].animation = { ...object.animation };
          }
        });
      });
    },
    calculateFirstScreenStartTime(index) {
      let startTime = 0;
      for (let i = 0; i < index; i++) {
        startTime += parseFloat(this.product.pages[i].animation.duration);
      }
      return startTime;
    },
    calculateSecondScreenTime(index) {
      let startTime = 0;
      for (let i = 0; i <= index; i++) {
        startTime += parseFloat(this.product.pages[i].animation.duration);
      }
      return startTime;
    },
    calculateScreenDuration(index) {
      return parseFloat(this.product.pages[index].animation.duration);
    },
    updateProductTransitionObjects() {
      let firstScreenStartTime  = 0;
      let secondScreenStartTime = 0;
      let firstScreenDuration   = 0;
      let secondScreenDuration  = 0;
      if (this.product.transitions) {
        for (let i = 0; i < this.product.transitions.length; i++) {
          firstScreenStartTime                              = this.calculateFirstScreenStartTime(i);
          secondScreenStartTime                             = this.calculateSecondScreenTime(i);
          firstScreenDuration                               = this.calculateScreenDuration(i);
          secondScreenDuration                              = this.calculateScreenDuration(i + 1);
          this.product.transitions[i].firstScreenStartTime  = firstScreenStartTime;
          this.product.transitions[i].firstScreenDuration   = firstScreenDuration;
          this.product.transitions[i].secondScreenStartTime = secondScreenStartTime;
          this.product.transitions[i].secondScreenDuration  = secondScreenDuration;
        }
      }
    },
    getLongestDuration(objects) {
      let longestDurationObject = null;
      let longestDuration       = 0;
      for (const obj of objects) {
        if (obj.videoDetails.endTime - obj.videoDetails.startTime > longestDuration) {
          longestDuration       = obj.videoDetails.endTime - obj.videoDetails.startTime;
          longestDurationObject = obj;
        }
      }
      return longestDurationObject;
    },
    updatePagesTransition(transition) {
      const activePageIndex = this.$store.getters['activeProduct/getPageAnimationIndex'];
      if (this.product.transitions) {
        this.product.transitions[activePageIndex] = _.cloneDeep(transition[0]);
      } else {
        this.product.transitions = _.cloneDeep(transition);
      }
    },
    addNewPageTransitionObject(transition) {
      if (this.product.transitions) {
        this.product.transitions.push(_.cloneDeep(transition[0]));
      } else {
        this.product.transitions = _.cloneDeep(transition);
      }
    },
    filterObjectsByType(objects) {
      const videoObjects = objects.filter(obj => obj.type === 'video');
      return videoObjects.length > 0 ? videoObjects : null;
    },
    updateActivePageDuration() {
      // EventBus.$emit(ApplicationEventTypes.UndoRedoEvents.ADDED, 'called by video object trimming');
      const cloneProduct = _.cloneDeep(this.product);
      // if (this.activeObject) { // ommitting check for testing
      const videoArray = this.filterObjectsByType(cloneProduct.pages[this.activePage].objectList);

      if (videoArray) {
        const longestDurationObject                                 = this.getLongestDuration(videoArray);
        const durationOfPage                                        = (longestDurationObject.videoDetails.endTime - longestDurationObject.videoDetails.startTime);
        cloneProduct.pages[this.activePage].animation.duration      = parseFloat(durationOfPage) > 2 ? durationOfPage : 2;
        const productDuration                                       = parseFloat(cloneProduct.pages[this.activePage].animation.duration);
        cloneProduct.pages[this.activePage].animation.timeLineWidth = productDuration * 28;
        this.product                                                = cloneProduct;
        this.activeObject                                           = null;
        this.updateProductTransitionObjects();
      }
      // }
    },
    updateProductPageDuration(duration) {
      duration                                                    = parseFloat(duration);
      const cloneProduct                                          = _.cloneDeep(this.product);
      cloneProduct.pages[this.activePage].animation.duration      = duration.toFixed(2);
      const productDuration                                       = parseFloat(cloneProduct.pages[this.activePage].animation.duration);
      cloneProduct.pages[this.activePage].animation.timeLineWidth = productDuration * 30;
      this.product                                                = cloneProduct;
      this.activeObject                                           = null;
      this.updateProductTransitionObjects();
    },
    applyPageTransition(style, index, speed) {
      const cloneProduct                        = _.cloneDeep(this.product);
      cloneProduct.pages[index].animation.style = style;
      cloneProduct.pages[index].animation.speed = speed;
      this.product                              = _.cloneDeep(cloneProduct);
    },
    setDefaultProduct() {
      this.product = _.cloneDeep(this.$store.getters.getSelectedProduct);
    },
    async onReplaceHighResResources() {
      await this.replaceResourcesWithHighResolutionResourceInProduct();
      this.updateProductColorList();
    },
    updateTextObjectValue({ value, index }) {
      if (this.product && this.product.pages[this.activePage] && this.product.pages[this.activePage].objectList[index]) {
        this.product.pages[this.activePage].objectList[index].Value        = value;
        this.product.pages[this.activePage].objectList[index].modifiedHtml = value;
      }
    },
    changeProductSizeFromDropDown(object) {
      this.onAddIntoPageWiseUndoRedoArray('called by size change');
      const newWidth  = object.name !== 'Common' ? parseInt(object.size.split('x')[0], 10) : parseInt(this.defaultProductWidth, 10);
      const newHeight = object.name !== 'Common' ? parseInt(object.size.split('x')[1], 10) : parseInt(this.defaultProductHeight, 10);
      const data      = {
        label: 'none',
        newWidth,
        newHeight,
      };
      if (parseInt(newWidth, 10) !== parseInt(this.getProductSizePixel.width, 10) || parseInt(newHeight, 10) !== parseInt(this.getProductSizePixel.height, 10)) {
        this.onChangeProductSizeAfterResize(data);
      }
    },
    async onChangeProductSizeAfterResize(data) {
      if ((data.newWidth && parseInt(data.newWidth, 10) < 1) || (data.newHeight && parseInt(data.newHeight, 10) < 1)) { return; }

      const cloneProduct = _.cloneDeep(this.product);

      const oldWidth  = parseFloat(this.getCropWidth);
      const oldHeight = parseFloat(this.getCropHeight);

      let newWidth  = data.newWidth ? parseFloat(data.newWidth) : oldWidth;
      let newHeight = data.newHeight ? parseFloat(data.newHeight) : oldHeight;

      const isOldNewWidthEqual  = Math.round(newWidth) === Math.round(oldWidth);
      const isOldNewHeightEqual = Math.round(newHeight) === Math.round(oldHeight);

      if (!cloneProduct.AllowCropping && isOldNewWidthEqual && isOldNewHeightEqual) {
        return;
      }

      const isCropX           = Math.round(parseFloat(this.product.XCrop)) > 0;
      const isCropY           = Math.round(parseFloat(this.product.YCrop)) > 0;
      const isCropProduct     = (isCropX && isCropY);
      const isWidthEqual      = ((!data.newWidth && Math.round(newWidth) === Math.round(oldWidth)) || (data.newWidth && Math.round(data.newWidth) === Math.round(oldWidth)));
      const isHeightEqual     = ((!data.newHeight && Math.round(newHeight) === Math.round(oldHeight)) || (data.newHeight && Math.round(data.newHeight) === Math.round(oldHeight)));
      const isCropWidthEqual  = Math.round(data.newWidth) === Math.round(cloneProduct.WidthCrop);
      const isCropHeightEqual = Math.round(data.newHeight) === Math.round(cloneProduct.HeightCrop);

      if (isCropProduct && isWidthEqual && isHeightEqual) {
        return;
      }

      if (isCropProduct && ((data.newWidth && isCropWidthEqual && !data.newHeight && isOldNewHeightEqual) || (data.newHeight && isCropHeightEqual && !data.newWidth && isOldNewWidthEqual))) {
        return;
      }

      this.product.pages.length > 1 && (EventBus.$emit('showHideLoader', true));

      if ((this.isProductSizeRatio) && data.label !== 'none') {
        if (data.label === 'Width') {
          newHeight = oldHeight * parseFloat(newWidth / oldWidth);
        } else if (data.label === 'Height') {
          newWidth = oldWidth * parseFloat(newHeight / oldHeight);
        }
      }
      const widthRatio  = parseFloat(newWidth / oldWidth);
      const heightRatio = parseFloat(newHeight / oldHeight);

      cloneProduct.XCrop && (cloneProduct.XCrop *= widthRatio);
      cloneProduct.YCrop && (cloneProduct.YCrop *= heightRatio);

      cloneProduct.WidthCrop && isCropX && (cloneProduct.WidthCrop = data.newWidth ? data.newWidth : newWidth);
      cloneProduct.HeightCrop && isCropY && (cloneProduct.HeightCrop = data.newHeight ? data.newHeight : newHeight);

      const keepActivePage = this.activePage;
      for (let y = 0; y < cloneProduct.pages.length; y++) {
        if (!this.$store.getters['activeProduct/getIsVideoMoodOn']) {
          if (this.getIsProductCrop.isShowCrop === false && y != this.activePage) { continue; }
        }

        cloneProduct.pages[y].width  = isCropX ? newWidth + (cloneProduct.XCrop * 2) : newWidth;
        cloneProduct.pages[y].height = isCropY ? newHeight + (cloneProduct.YCrop * 2) : newHeight;

        for (let i = 0; i < cloneProduct.pages[y].objectList.length; i++) {
          if (cloneProduct.pages[y].objectList[i].type === 'image') {
            cloneProduct.pages[y].objectList[i].X *= widthRatio;
            cloneProduct.pages[y].objectList[i].Y *= heightRatio;
            if (cloneProduct.pages[y].objectList[i].Name === 'z-border') {
              cloneProduct.pages[y].objectList[i].scaleX *= widthRatio;
              cloneProduct.pages[y].objectList[i].scaleY *= heightRatio;
            } else {
              cloneProduct.pages[y].objectList[i].Width  *= widthRatio;
              cloneProduct.pages[y].objectList[i].Height *= heightRatio;
            }
            if (cloneProduct.pages[y].objectList[i].ImageType === 'SVGImage') {
              const shapeObject                  = cloneProduct.pages[y].objectList[i];
              shapeObject.SvgProperty.svgScaleX *= widthRatio;
              shapeObject.SvgProperty.svgScaleY *= heightRatio;
              const isTransformStyle             = shapeObject.SvgProperty.content.includes(`style="transform-origin: left top; transform: ${shapeObject.SvgProperty.style};"`);
              const isTransformStyleWith0Px      = shapeObject.SvgProperty.content.includes(`style="transform-origin: left top 0px; transform: ${shapeObject.SvgProperty.style};"`);
              if (isTransformStyle || isTransformStyleWith0Px) {
                if (isTransformStyleWith0Px) {
                  shapeObject.SvgProperty.content = shapeObject.SvgProperty.content.replace(`style="transform-origin: left top 0px; transform: ${shapeObject.SvgProperty.style};"`, `style="transform-origin: left top; transform: scale(${shapeObject.SvgProperty.svgScaleX}, ${shapeObject.SvgProperty.svgScaleY});"`);
                } else {
                  shapeObject.SvgProperty.content = shapeObject.SvgProperty.content.replace(`style="transform-origin: left top; transform: ${shapeObject.SvgProperty.style};"`, `style="transform-origin: left top; transform: scale(${shapeObject.SvgProperty.svgScaleX}, ${shapeObject.SvgProperty.svgScaleY});"`);
                }
                shapeObject.SvgProperty.style = `scale(${shapeObject.SvgProperty.svgScaleX}, ${shapeObject.SvgProperty.svgScaleY})`;
              }
            }
          }
          if (cloneProduct.pages[y].objectList[i].type === 'shape') {
            cloneProduct.pages[y].objectList[i].X      *= widthRatio;
            cloneProduct.pages[y].objectList[i].Y      *= heightRatio;
            cloneProduct.pages[y].objectList[i].Width  *= widthRatio;
            cloneProduct.pages[y].objectList[i].Height *= heightRatio;
            const shapeObject                           = cloneProduct.pages[y].objectList[i];
            shapeObject.svgScaleX                      *= widthRatio;
            shapeObject.svgScaleY                      *= heightRatio;
            if (document.getElementById(shapeObject.Id) && document.getElementById(shapeObject.Id).querySelector('svg') && (shapeObject.shapeType === 'polygon' || shapeObject.shapeType === 'ellipses')) {
              const shapeElement = document.getElementById(shapeObject.Id).querySelector('svg');
              shapeObject.Width  = parseFloat(shapeElement.getAttribute('width')) * shapeObject.svgScaleX;
              shapeObject.Height = parseFloat(shapeElement.getAttribute('height')) * shapeObject.svgScaleY;
            }
          }
          if (cloneProduct.pages[y].objectList[i].type === 'text') {
            y;
            if (widthRatio == heightRatio) {
              const oldOffsetWidth  = (cloneProduct.pages[y].objectList[i].Width * cloneProduct.pages[y].objectList[i].scaleX - cloneProduct.pages[y].objectList[i].Width) / 2;
              const oldOffsetHeight = (cloneProduct.pages[y].objectList[i].Height * cloneProduct.pages[y].objectList[i].scaleY - cloneProduct.pages[y].objectList[i].Height) / 2;

              cloneProduct.pages[y].objectList[i].scaleY *= widthRatio;
              cloneProduct.pages[y].objectList[i].scaleX *= widthRatio;

              cloneProduct.pages[y].objectList[i].X = (cloneProduct.pages[y].objectList[i].X - oldOffsetWidth) * widthRatio;
              cloneProduct.pages[y].objectList[i].Y = (cloneProduct.pages[y].objectList[i].Y - oldOffsetHeight) * heightRatio;

              const newOffsetWidth  = (cloneProduct.pages[y].objectList[i].Width * cloneProduct.pages[y].objectList[i].scaleX - cloneProduct.pages[y].objectList[i].Width) / 2;
              const newOffsetHeight = (cloneProduct.pages[y].objectList[i].Height * cloneProduct.pages[y].objectList[i].scaleY - cloneProduct.pages[y].objectList[i].Height) / 2;

              cloneProduct.pages[y].objectList[i].X += newOffsetWidth;
              cloneProduct.pages[y].objectList[i].Y += newOffsetHeight;
            } else {
              cloneProduct.pages[y].objectList[i].X      *= widthRatio;
              cloneProduct.pages[y].objectList[i].Y      *= heightRatio;
              cloneProduct.pages[y].objectList[i].Width  *= widthRatio;
              cloneProduct.pages[y].objectList[i].Height *= heightRatio;

              let element       = document.createElement('div');
              element.innerHTML = cloneProduct.pages[y].objectList[i].Value;
              element           = element.cloneNode(true);
              if (element) {
                const childList    = element.querySelectorAll('SPAN , FONT, li , ul, div');
                const ratioForText = parseFloat((widthRatio * heightRatio));
                if (childList.length) {
                  for (const current of childList) {
                    if (current.getAttribute('style') && current.getAttribute('style').indexOf('font-size:') !== -1) {
                      current.style.fontSize = `${parseFloat(parseFloat(current.style.fontSize) * ratioForText)}px`;
                    }
                  }
                }
                cloneProduct.pages[y].objectList[i].fontSize                    = parseFloat(cloneProduct.pages[y].objectList[i].fontSize) * ratioForText;
                cloneProduct.pages[y].objectList[i].valuesForLeftPanel.fontSize = cloneProduct.pages[y].objectList[i].fontSize;
                cloneProduct.pages[y].objectList[i].Value                       = element.outerHTML;
                cloneProduct.pages[y].objectList[i].modifiedHtml                = element.outerHTML;
              }
            }
          }
        }


        if (this.product.pages.length > 1) {
          this.product.pages[y] = cloneProduct.pages[y];
          this.activePage       = y;
          await new Promise(r => setTimeout(r, 1000));
        }
      }
      this.$nextTick(() => {
        EventBus.$emit('showHideLoader', false);
        this.activePage = keepActivePage;
        this.product    = cloneProduct;
        /*
         * resizing all objects takes time
         * wait for sometime to save to undo-redo array
         */

        setTimeout(() => {
          this.onAddIntoPageWiseUndoRedoArray('called by size change');
        }, 1000);
      });
    },
    openDetailSection() {
      this.DetailSection.isOpen = !this.DetailSection.isOpen;
      this.DetailSection.isOpen && EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED, this.onClearSelection);
    },
    closeDetailsection() {
      this.DetailSection.isOpen = false;
    },

    async extractColorFromProduct() {
      const pages     = this.product.pages;
      const colorList = [];
      for (let pageIndex = 0; pageIndex < pages.length; pageIndex++) {
        const { objectList } = pages[pageIndex];
        for (let objectIndex = 0; objectIndex < objectList.length; objectIndex++) {
          const object = objectList[objectIndex];
          switch (object.type) {
            case 'text':
              object.color && (object.color = object.color.trim()
                .startsWith('#') ? hexToRgb(object.color) : object.color);
              object.color && (object.color = object.color.replaceAll(' ', ''));
              object.color && !colorList.includes(object.color) && (colorList.push(object.color));
              const textColor = this.extractColorFromText(object.modifiedHtml, colorList);
              textColor.length && (colorList.splice(colorList.length, 0, ...textColor));
              break;
            case 'image':
              if (object.ImageType == 'SVGImage') {
                object.SvgProperty.DefaultColor = object.SvgProperty.DefaultColor.trim().startsWith('#') ? hexToRgb(object.SvgProperty.DefaultColor) : object.SvgProperty.DefaultColor;
                object.SvgProperty.DefaultColor = object.SvgProperty.DefaultColor.replaceAll(' ', '');
                object.SvgProperty.DefaultColor && object.SvgProperty.DefaultColor.startsWith('rgb(') && (object.SvgProperty.DefaultColor = this.getRGBAColor(object.SvgProperty.DefaultColor));
                object.SvgProperty.DefaultColor && object.SvgProperty.DefaultColor.trim()
                  .startsWith('rgba') && !colorList.includes(object.SvgProperty.DefaultColor) && (colorList.push(object.SvgProperty.DefaultColor));
                break;
              }
              await object.ImageType == 'WhiteboxLogo' && ((async (url, colorList) => {
                if (url.trim().endsWith('.svg')) {
                  await this.extractColorFromSvg(url)
                    .then((svgColors) => {
                      if (svgColors.length < 10) {
                        svgColors.forEach((color) => {
                          color = color.replaceAll(' ', '');
                          color && color.startsWith('rgb(') && (color = this.getRGBAColor(color));
                          if (!colorList.includes(color)) {
                            colorList.push(color);
                          }
                        });
                      }
                    });
                }
              })(object.DefaultImageUrl, colorList));
              break;
            case 'shape':
              object.DefaultColor = object.DefaultColor.trim()
                .startsWith('#') ? hexToRgb(object.DefaultColor) : object.DefaultColor;
              object.DefaultColor = object.DefaultColor.replaceAll(' ', '');
              object.DefaultColor && object.DefaultColor.startsWith('rgb(') && (object.DefaultColor = this.getRGBAColor(object.DefaultColor));
              object.DefaultColor && object.DefaultColor.trim()
                .startsWith('rgba') && !colorList.includes(object.DefaultColor) && (colorList.push(object.DefaultColor));
          }
        }
      }
      return colorList;
    },
    extractColorFromText(htmlString, colorList) {
      const divElement     = document.createElement('div');
      const textColor      = [];
      divElement.innerHTML = htmlString;

      if (!divElement.firstElementChild) { return []; }
      const spanList = divElement.firstElementChild.querySelectorAll('span, font');
      if (spanList.length) {
        for (let spanIndex = 0; spanIndex < spanList.length; spanIndex++) {
          let color = spanList[spanIndex].style.color; // window.getComputedStyle(spanList[spanIndex], null).getPropertyValue('color')
          color     = color.replaceAll(' ', '');
          color     = color.trim()
            .startsWith('#') ? hexToRgb(color) : color;

          color && color.startsWith('rgb(') && (color = this.getRGBAColor(color));
          color && color.trim()
            .startsWith('rgba') && !textColor.includes(color) && !colorList.includes(color) && (textColor.push(color));
        }
      }
      return textColor;
    },
    getRGBAColor(color) {
      const colorArr = color.trim().replace('rgb(', '').replace(')', '').split(',');
      if (colorArr.length && colorArr.length < 3) { return color; }
      return `rgba(${colorArr[0]},${colorArr[1]},${colorArr[2]},1)`;
    },
    async extractColorFromSvg(url) {
      const response = await axios.post('https://pdf-processing.bankmarketingcenter.com/node/svgcolor', { 'svg-type': 'url', svg: url });
      const { data } = response;
      return data.code == 200 && data.colorList.success ? response.data.colorList.colors : [];
    },
    changeProductSize(unit) {
      this.product.IsInch = unit == 'Inches';
    },
    closeModalsDefault() {
      EventBus.$emit('closeOpenedModals', this.modalTruthy);
    },
    closeModals(e) {
      EventBus.$emit('modalsCloser', this.checkModal);
    },

    onDeleteProductPage() {
      if (this.product.pages.length !== 1) {
        this.deletePageDataFromPageWiseUndoRedoArray();
        this.product.pages.splice(this.activePage, 1);
        this.product.transitions.splice(this.activePage - 1, 1);
        this.productPagesLength = this.product.pages.length;
        const tempActivePage    = this.activePage;
        this.activePage         = null;
        this.activePage         = tempActivePage;
        this.activePage > 0 && (--this.activePage);
        this.updateProductTransitionObjects();
      }
    },
    onDuplicateProductPage() {
      if (this.product.pages.length > 14) {
        alert('page limit exceeded');
        return;
      }
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.SET_TARGET_EMPTY);
      setTimeout(() => {
        const tempDuplicateProductPage = _.cloneDeep(this.product.pages[this.activePage]);
        tempDuplicateProductPage.objectList.forEach((object) => {
          object.Id         = uuidv4();
          object.isSelected = false;
          object.editor     = null;
          object.PageNo     = this.activePage + 1;
          object.type == 'text' && object.modifiedHtml !== object.Value && (object.Value = object.modifiedHtml);
        });
        this.product.pages.push(tempDuplicateProductPage);
        const transition = [
          {
            name:                  'transitionNone',
            speed:                 50,
            time:                  5.0,
            firstScreenStartTime:  0,
            firstScreenDuration:   5,
            secondScreenStartTime: 5,
            secondScreenDuration:  5,
          }];
        this.addNewPageTransitionObject(transition);
        this.updateProductTransitionObjects();
        this.productPagesLength = this.product.pages.length;
        this.duplicatePageInPageWiseUndoRedo();
      }, 10);
    },
    onCreateNewProductPage() {
      if (this.product.pages.length > 14) {
        alert('page limit exceeded');
        return;
      }
      const tempCreateNewProductPage      = _.cloneDeep(this.product.pages[this.activePage]);
      tempCreateNewProductPage.objectList = [];
      tempCreateNewProductPage.baseImage  = '';// https://trello.com/c/SQzYEgbz/682-adding-new-page-copying-background-image
      tempCreateNewProductPage.animation  = {
        speed:         1,
        style:         'pageAnimationNone',
        startTime:     0.0,
        duration:      5.0,
        onEnter:       false,
        onExit:        false,
        timeLineWidth: 140,
      };
      let tempElementArrayCount           = this.product.pages.push(tempCreateNewProductPage);
      (tempElementArrayCount--) && (this.activePage = tempElementArrayCount);
      this.productPagesLength = this.product.pages.length;
      const transition        = [
        {
          name:                  'transitionNone',
          speed:                 50,
          time:                  5.0,
          firstScreenStartTime:  0,
          firstScreenDuration:   0,
          secondScreenStartTime: 0,
          secondScreenDuration:  5,
        }];
      this.addNewPageTransitionObject(transition);
      this.updateProductTransitionObjects();
      this.$store.commit('updateSelectedProduct', _.cloneDeep(this.product));
      this.addNewPageInPageWiseUndoRedo();
    },
    onChangeProductPage(pageindex) { this.activePage = pageindex; },
    loadAllAddressBoxes(productId) {
      const baseURL   = this.$store.getters.getBaseUrl;
      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url       = `${baseURL}/web_service.aspx?method=GetBankAllAddressBoxesNewEditor&domainURL=https://${domainUrl}.com/&bankId=${this.$store.getters.getBankId}&productId=${productId}`;


      const oReq  = new XMLHttpRequest();
      const _this = this;
      oReq.addEventListener('load', (Response) => {
        const xmlParser         = new DOMParser();
        const convertedDoM      = xmlParser.parseFromString(Response.target.response, 'text/xml');
        const address           = JSON.parse(convertedDoM.getElementsByTagName('GetBankAllAddressBoxesNewEditorResult')[0].innerHTML);
        let addressArr          = address.BanksAddresses ? address.BanksAddresses : [];
        const equalHousingLogos = address.EqualHousingLogos ? address.EqualHousingLogos : [];
        const ncuaLogos         = address.NcuaLogos ? address.NcuaLogos : [];
        const fdicLogos         = address.FdicLogos ? address.FdicLogos : [];
        addressArr              = addressArr.filter(Boolean);
        addressArr.forEach(async (item) => {
          await axios.post(`https://pdf-processing.bankmarketingcenter.com/node/pdf2svg/pdf2svg?pdf-url=${item.HighResImagePath}&productId=${productId}`)
            .then((res) => {
              item.DefaultImagePath = res.data.svg;
            })
            .catch((e) => {
              console.error(e);
            });
        });
        equalHousingLogos.forEach(async (item) => {
          await axios.post(`https://pdf-processing.bankmarketingcenter.com/node/pdf2svg/pdf2svg?pdf-url=${item.PdfUrl}&productId=${productId}`)
            .then((res) => {
              item.DefaultImagePath = res.data.svg;
            })
            .catch((e) => {
              console.error(e);
            });
        });
        fdicLogos.forEach(async (item) => {
          await axios.post(`https://pdf-processing.bankmarketingcenter.com/node/pdf2svg/pdf2svg?pdf-url=${item.PdfUrl}&productId=${productId}`)
            .then((res) => {
              item.DefaultImagePath = res.data.svg;
            })
            .catch((e) => {
              console.error(e);
            });
        });
        ncuaLogos.forEach(async (item) => {
          await axios.post(`https://pdf-processing.bankmarketingcenter.com/node/pdf2svg/pdf2svg?pdf-url=${item.PdfUrl}&productId=${productId}`)
            .then((res) => {
              item.DefaultImagePath = res.data.svg;
            })
            .catch((e) => {
              console.error(e);
            });
        });
        setTimeout(() => {
          const adBoxes             = addressArr.filter(item => item.DefaultImagePath); // remove empty entries
          _this.ProductAddressBoxes = adBoxes;
          this.$store.commit('updateAddressBoxes', adBoxes);
          this.$store.commit('updateFdicLogos', fdicLogos);
          this.$store.commit('updateNcuaLogos', ncuaLogos);
          this.$store.commit('updateHousingLogos', equalHousingLogos);
        }, 0);
      });
      oReq.addEventListener('error', (e) => {
        console.error(e);
      });
      oReq.open('GET', url);
      oReq.send();
    },
    loadSvgShapes() {
      // /https://wysiwyg.bankmarketingcenter.com/web_service.aspx?method=GetFontsByBank&domainURL=https://www.bankmarketingcenter.com/&bankId=fde5ed9d-816f-43fd-89f3-97a542947193&productId=d07a80b7-bf50-464e-bfe2-604d48849d83

      //
      // const url = new URL('https://dev2.wysiwyg.bankmarketingcenter.com/web_service.aspx?');
      // url.searchParams.set('method', 'GetSvgShapes');
      // url.searchParams.set('domainURL', 'https://www.bankmarketingcenter.com/');
      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;

      const url = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=GetSvgShapesByBank&bankId=${this.$store.getters.getBankId}&domainURL=https://${domainUrl}.com/`;

      const oReq  = new XMLHttpRequest();
      const _this = this;
      oReq.addEventListener('load', (Response) => {
        const parser      = new DOMParser();
        const xmlParsed   = parser.parseFromString(Response.target.response, 'text/xml');
        let svgCollection = xmlParsed.getElementsByTagName('GetSvgShapesByBankResult');
        svgCollection[0] && (svgCollection = svgCollection[0].innerHTML);
        const parse = JSON.parse(svgCollection);
        this.$store.commit('updataProductSvg', parse);
      });
      oReq.addEventListener('error', (e) => {
        console.error(e);
      });
      oReq.open('GET', url);
      oReq.send();
    },
    loadSvgShapeCategories() {
      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url       = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=SearchSvgShapeCategory&bankId=${this.$store.getters.getBankId}&domainURL=https://${domainUrl}.com/`;

      const oReq = new XMLHttpRequest();
      oReq.addEventListener('load', (Response) => {
        console.error('loading SVG categories', Response);
        const parser      = new DOMParser();
        const xmlParsed   = parser.parseFromString(Response.target.response, 'text/xml');
        let svgCollection = xmlParsed.getElementsByTagName('SearchSvgShapeCategoryResult');
        svgCollection[0] && (svgCollection = svgCollection[0].innerHTML);
        const parse = JSON.parse(svgCollection);
        this.$store.commit('updateSVGCategories', parse);
      });
      oReq.addEventListener('error', (e) => {
        console.log('Error in loading Shapes Categories', e);
      });
      oReq.open('GET', url);
      oReq.send();
    },
    loadFontsByBank(productId) {
      const urlSearchPart      = window.location.search;
      const newUrlSearchParams = new URLSearchParams(urlSearchPart);
      const userId             = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : null;
      const domainUrl          = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url                = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=GetFontsByBankIdIncludingUserFavorites&domainURL=https://${domainUrl}.com/&bankId=${this.$store.getters.getBankId}&productId=${productId}&userId=${userId}`;


      const oReq  = new XMLHttpRequest();
      const _this = this;
      oReq.addEventListener('load', (Response) => {
        const xmlParser    = new DOMParser();
        const convertedDoM = xmlParser.parseFromString(Response.target.response, 'text/xml');
        const fontsResult  = convertedDoM.getElementsByTagName('FontInfo');
        let jsonFonts      = [];
        console.log(fontsResult);
        for (let i = 0; i < fontsResult.length; i++) {
          const item = fontsResult[i];
          try {
            const jsonFontObj = {
              name:        item.getElementsByTagName('Name')[0].textContent,
              path:        item.getElementsByTagName('VirtualPath')[0].textContent,
              isFavourite: JSON.parse(item.getElementsByTagName('IsFavourite')[0].textContent),
              id:          item.getElementsByTagName('Id')[0].textContent,
            };
            jsonFonts.push(jsonFontObj);
          } catch (e) {
            console.log('following item fail', e);
          }
        }
        jsonFonts =  [...jsonFonts.reduce((map, obj) => map.set(obj.name, obj), new Map()).values()];
        jsonFonts.sort((a, b) => {
          if (a.isFavourite) { return -1; }
          if (b.isFavourite) { return 1; }
          return 0;
        });
        this.$store.commit('setproductfontarray', jsonFonts);
      });
      oReq.addEventListener('error', (e) => {
        this.loadFonts(''); // if the font api data loading is fail then the local font load
        console.error(e);
      });
      oReq.open('GET', url);
      oReq.send();
    },
    fontFamilyLoad(jsonFonts) {
      jsonFonts       = jsonFonts.filter((value, index) => jsonFonts.indexOf(value) === index);
      const observers = [];
      jsonFonts.forEach((cur) => {
        const obs = new FontFaceObserver(cur);
        observers.push(obs.load());
      });
      Promise.all(observers)
        .then((fonts) => {
          fonts.forEach(() => {
          });
        })
        .catch((err) => {
          console.warn('Some critical font are not available:', err);
        });
    },
    async getFavouriteSizes() {
      const urlSearchPart      = window.location.search;
      const newUrlSearchParams = new URLSearchParams(urlSearchPart);
      const userId             = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : null;

      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url       = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=GetUserFavoriteSizes&domainURL=https://${domainUrl}.com/&userId=${userId}`;

      const oReq = new XMLHttpRequest();
      oReq.addEventListener('load', (Response) => {
        const parser              = new DOMParser();
        const xmlParsed           = parser.parseFromString(Response.target.response, 'text/xml');
        const favouriteSizeResult = xmlParsed.querySelector('GetUserFavoriteSizesResult');
        const parse               = (favouriteSizeResult && favouriteSizeResult.textContent.length > 0) ? JSON.parse(favouriteSizeResult.textContent) : [];
        this.$store.commit('updateFavouriteSizes', parse);
      });
      oReq.addEventListener('error', (e) => {
        console.error(e);
      });
      oReq.open('GET', url);
      oReq.send();
    },
    addFavouriteSizeToAPI(data) {

    },

    deleteFavouriteSize(id) {
      const urlSearchPart      = window.location.search;
      const newUrlSearchParams = new URLSearchParams(urlSearchPart);
      const userId             = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : null;

      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url       = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=DeleteUserFavoriteSize&domainURL=https://${domainUrl}.com/&userId=${userId}&sizeId=${id}`;

      const oReq = new XMLHttpRequest();
      oReq.addEventListener('load', (Response) => {
        const parser            = new DOMParser();
        const xmlParsed         = parser.parseFromString(Response.target.response, 'text/xml');
        let favouriteSizeResult = xmlParsed.getElementsByTagName('DeleteUserFavoriteSizeResult');
        favouriteSizeResult[0] && (favouriteSizeResult = favouriteSizeResult[0].innerHTML);
        const parse = JSON.parse(favouriteSizeResult);
        this.$store.commit('updateFavouriteSizes', parse);
      });
      oReq.addEventListener('error', (e) => {
        console.error(e);
      });
      oReq.open('GET', url);
      oReq.send();
    },
    loadPmsColorNewInfo(product, productXML = null) {
      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url       = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=GetPmsColorNewInfo&domainURL=https://${domainUrl}.com/&bankId=${this.$store.getters.getBankId}&productId=${product.Id}`;


      const oReq = new XMLHttpRequest();
      oReq.addEventListener('load', async (Response) => {
        const xmlParser            = new DOMParser();
        const convertedDoM         = xmlParser.parseFromString(Response.target.response, 'text/xml');
        const AllNewPmsColorsChild = convertedDoM.getElementsByTagName('AllNewPmsColors')[0].getElementsByTagName('PmsColorNew');
        const yourColors           = convertedDoM.getElementsByTagName('BankNewPmsColors')[0].getElementsByTagName('PmsColorNew');
        const yourColorArray       = [];
        if (yourColors) {
          for (const color of yourColors) {
            yourColorArray.push(color.getElementsByTagName('DisplayColorTextRGB')[0].innerHTML);
          }
          this.$store.commit('setYourColor', yourColorArray);
        }

        const temArray = [];
        for (const element of AllNewPmsColorsChild) {
          const tempObj                   = {};
          tempObj.Id                      = element.getElementsByTagName('Id')[0].innerHTML;
          tempObj.Name                    = element.getElementsByTagName('Name')[0].innerHTML;
          tempObj.NumberName              = element.getElementsByTagName('NumberName')[0].innerHTML;
          tempObj.IsCustom                = element.getElementsByTagName('IsCustom')[0].innerHTML;
          tempObj.Ordering                = element.getElementsByTagName('Ordering')[0].innerHTML;
          tempObj.DisplayColorTextCMYK    = element.getElementsByTagName('DisplayColorTextCMYK')[0].innerHTML;
          tempObj.DisplayColorTextCMYKHex = element.getElementsByTagName('DisplayColorTextCMYKHex')[0].innerHTML;
          tempObj.DisplayColorTextRGB     = element.getElementsByTagName('DisplayColorTextRGB')[0].innerHTML;
          temArray.push(tempObj);
        }
        this.$store.commit('setAllNewPmsColors', temArray);
        productXML && (await this.parseProductObject(productXML, product));
        productXML && (this.parseProductProperties(productXML));
      });
      oReq.addEventListener('error', async (e) => {
        productXML && (await this.parseProductObject(productXML, product));
        productXML && (this.parseProductProperties(productXML, product));
      });
      oReq.open('GET', url);
      oReq.send();
    },
    deSelectActiveObject() {
      if (this.activeObject !== null) {
        this.activeObject = null;
      }
    },
    changeProductAllowCropping(allowCropping) {
      this.product.AllowCropping = allowCropping;
      this.$nextTick(() => {
        const resizeEvent = window.document.createEvent('UIEvents');
        resizeEvent.initUIEvent('resize', true, false, window, 0);
        window.dispatchEvent(resizeEvent);
      });
    },
    onToggleProductSizeRatioFlag() {
      this.isProductSizeRatio = !this.isProductSizeRatio;
    },
    onChangeProductName(newName) {
      const target = newName === 'reset' ? this.defaultProductName : newName;
      // let cloneProduct = _.cloneDeep(this.product);
      // cloneProduct.Name = newName;
      this.product.Name = target;
    },
    // onChangeProductSizeAfterResize(data){
    //   let cloneProduct=_.cloneDeep(this.product)
    //   let newValue=this.product.IsInch ? parseFloat(data.value)/0.013888888888888888 : parseFloat(data.value)
    //   let cropValue=data.label==='Width' ? parseInt(cloneProduct.XCrop)*2 : data.label==='Height' ? parseInt(cloneProduct.YCrop)*2 : 0
    //   let oldValue=this.getProductSizePixel[data.label.toLowerCase()]+cropValue
    //   let ratio=newValue/oldValue
    //   for(let y=0;y<cloneProduct.pages.length;y++){
    //     for(let i=0 ; i<cloneProduct.pages[y].objectList.length;i++){
    //       cloneProduct.pages[y][data.label.toLowerCase()]=newValue
    //       if(data.label==='Width'){
    //         cloneProduct.XCrop=parseInt(parseInt(cloneProduct.XCrop)*ratio)
    //         // cloneProduct.WidthCrop=parseInt(parseInt(cloneProduct.WidthCrop)*ratio)
    //       }
    //       else if(data.label==='Height'){
    //         cloneProduct.YCrop=parseInt(parseInt(cloneProduct.YCrop)*ratio)
    //         // cloneProduct.HeightCrop=parseInt(parseInt(cloneProduct.HeightCrop)*ratio)
    //       }
    //       cloneProduct.pages[y].objectList[i][data.label]*=ratio
    //       data.label=== 'Width' && (cloneProduct.pages[y].objectList[i].X*=ratio)
    //       data.label=== 'Height' && (cloneProduct.pages[y].objectList[i].Y*=ratio)
    //       if(cloneProduct.pages[y].objectList[i].type==='text'){
    //         let element=document.createElement("div")
    //         element.innerHTML=cloneProduct.pages[y].objectList[i].Value
    //         element=element.firstElementChild
    //         element=element.cloneNode(true)
    //         if (element){
    //           let childList=element.querySelectorAll('SPAN , FONT')
    //           if(childList.length){
    //             for(let i=0 ; i<childList.length ; i++){
    //               if(childList[i].getAttribute("style").indexOf("font-size:") !== -1){
    //                 childList[i].style.fontSize=parseInt(childList[i].style.fontSize)*ratio+'px'
    //               }
    //             }
    //           }
    //           cloneProduct.pages[y].objectList[i].fontSize*=ratio
    //           cloneProduct.pages[y].objectList[i].Value=element.outerHTML
    //           cloneProduct.pages[y].objectList[i].modifiedHtml=element.outerHTML
    //         }
    //       }
    //     }
    //   }
    //
    //   this.$nextTick(()=>{
    //     this.product=cloneProduct
    //   })
    //
    // },

    onChangeAllowAlignmentGuides() {
      const cloneProduct              = _.cloneDeep(this.product);
      cloneProduct.isAlignmentGuideOn = !cloneProduct.isAlignmentGuideOn;
      this.product                    = cloneProduct;
      this.onObjectSelectedCleared();
    },
    onToggleGrayScale() {
      const cloneProduct       = _.cloneDeep(this.product);
      cloneProduct.IsGrayscale = !cloneProduct.IsGrayscale;
      this.product             = cloneProduct;
    },
    onToggleRuler() {
      if (this.isRulerOn) {
        this.$store.commit('setHorizontalGuides', []);
        this.$store.commit('setVerticalGuides', []);
      }
      this.isRulerOn = !this.isRulerOn;
    },
    onUpdateHTML(data) {
      this.product.pages[this.activePage].objectList.forEach((obj) => {
        obj.Id === data.id && (obj.Value = obj.modifiedHtml = data.html);
      });
    },
    sortContentListArray() {
      if (!this.product || !this.product.pages || !this.product.pages[this.activePage].objectList) { return; }
      for (let i = 0; i < this.product.pages.length; i++) {
        this.product.pages[i].objectList.sort(helperFunctionToReverseSortByObjectKey('PdfSortOrder'));
      }
      this.onUpdateContentListIndexOnLayerSwap(this.product.pages[this.activePage].objectList);
    },
    onUpdateContentListIndexOnLayerSwap(updatedArray) {
      const _this = this;
      let z       = 0;

      for (let i = updatedArray.length; i > 0; i--) {
        _this.product.pages[_this.activePage].objectList[z]              = updatedArray[z];
        _this.product.pages[_this.activePage].objectList[z].PdfSortOrder = i - 1;
        _this.product.pages[_this.activePage].objectList[z].elementIndex = z;
        z++;
      }

      if (_this.product.pages[_this.activePage].objectList.length > updatedArray.length) {
        const diff = _this.product.pages[_this.activePage].objectList.length - updatedArray.length;
        _this.product.pages[_this.activePage].objectList.splice(updatedArray.length, diff);
      }
      if (this.activeObject) {
        const { elementIndex } = this.activeObject;
        const selectedObject           = this.product.pages[this.activePage].objectList[elementIndex];
        this.activeObject = selectedObject;
      }
    },
    updateIsLoaderVisible(bool) {
      if (bool === true || bool === false) {
        this.isLoaderVisible = bool;
      }
    },

    updatePageContent(page) {
      this.product.pages[this.activePage].objectList = page;
    },
    clickOnMainContent() {
      // closing the colorPickerComponent
      this.$store.commit('setIsOpen', false);
    },
    selectedProductRecieved(data) {
      this.parseProductFromXML(data);
    },
    updateStyle() {
      if ('VerticalCenter') {
        this.activeObject.alignItem = 'center';
      }
    },
    onUpdateObjectAfterCrop(data) {
      const tempProduct = _.cloneDeep(this.product);
      Object.assign(tempProduct.pages[this.activePage].objectList[data.tempIndex], data);
      this.product = tempProduct;
      EventBus.$emit(ApplicationEventTypes.UndoRedoEvents.ADDED, 'cropped Image Url');
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED);
    },
    onObjectSelected(activeObject) {
      this.activeObject = activeObject;
      EventBus.$emit(ApplicationEventTypes.AnimationEvent.STOP_OBJECT_ANIMATION);
    },
    onObjectSelectedCleared() {
      this.activeObject = null;
      EventBus.$emit(ApplicationEventTypes.AnimationEvent.STOP_OBJECT_ANIMATION);
      this.$store.commit('activeProduct/updatePageAnimationIndex', -1);
    },

    parseProductFromXML(xmlObject) {
      const urlSearchPart      = window.location.search;
      const newUrlSearchParams = new URLSearchParams(urlSearchPart);
      let resultVariable       = 'GetProductInfoResult';
      (newUrlSearchParams.has('orderitem_id') || newUrlSearchParams.has('orderitem_Id')) && (resultVariable = 'GetProductInfoForOrderResult');
      const xmlParser    = new DOMParser();
      const convertedDoM = xmlParser.parseFromString(xmlObject, 'text/xml');
      const productXML   = convertedDoM.getElementsByTagName(resultVariable)[0];
      // console.log('Product DATA', productXML)
      const pageWidth  = productXML.getElementsByTagName('PageWidths')[0];
      const pageHeight = productXML.getElementsByTagName('PageHeights')[0];

      /* OP1: Extract all elements at root of product and convert to XML */
      const json = {};
      for (let i = 0; i < productXML.childElementCount; i++) {
        let val = productXML.childNodes[i].innerHTML;
        if (productXML.childNodes[i].innerHTML == 'true' || productXML.childNodes[i].innerHTML == 'false') {
          val = productXML.childNodes[i].innerHTML == 'true';
        }
        json[productXML.childNodes[i].tagName] = val;
      }
      /* OP1: Ended */


      const pages               = [];
      const productBaseImages   = this.extractProductBaseImages(json.BaseImage);
      const xCropValue          = json.XCrop ? Number(json.XCrop) * 2 : 0;
      const yCropValue          = json.YCrop ? Number(json.YCrop) * 2 : 0;
      const isOldOrder          = json.hasOwnProperty('DesignJson');
      const tempArrayforUndRedo = [];
      for (let pageIndex = 0; pageIndex < pageWidth.children.length; pageIndex++) {
        let width  = parseFloat(pageWidth.children[pageIndex].innerHTML); // this is actual width of product
        let height = parseFloat(pageHeight.children[pageIndex].innerHTML);// this is actual height of product

        isOldOrder && xCropValue > 0 && (width  += xCropValue);
        isOldOrder && yCropValue > 0 && (height += yCropValue);

        pages.push({
          objectList: [],
          width,
          height,
          baseImage:  productBaseImages ? productBaseImages[pageIndex] : this.product.BaseImage,
          animation:  {
            speed:         1,
            style:         'pageAnimationNone',
            startTime:     0.0,
            duration:      5.0,
            onEnter:       false,
            onExit:        false,
            timeLineWidth: 140,
          },
        });
        tempArrayforUndRedo.push({
          animation: {
            speed:         1,
            style:         'pageAnimationNone',
            startTime:     0.0,
            duration:      5.0,
            onEnter:       false,
            onExit:        false,
            timeLineWidth: 140,
          },
        });
        if (pageIndex == 5) { break; } // TODO:we have 6 page to display
      }
      // this.pagesDurationUndoRedoArray.push(tempArrayforUndRedo);
      // this issue is on old order, the fixed is recalculate the width and height crop
      if (isOldOrder && pages.length) {
        const { width, height } = pages[0];
        const isChangeWidthCrop = (json.WidthCrop + xCropValue) != width;
        isChangeWidthCrop && (json.WidthCrop = width - xCropValue);
        const isChangeHeightCrop = (json.HeightCrop + yCropValue) != height;
        isChangeHeightCrop && (json.HeightCrop = height - yCropValue);
      }

      if (pages.length > 0) {
        this.activePage = 0;
      } else {
        return;
      }
      this.product               = {};
      this.product               = json;
      this.product.isVideoEditor = !!(this.product.isVideoEditor);
      this.product.isVideo       = !!(this.product.isVideo);
      if (newUrlSearchParams.has('video_mode')) {
        const video_mode = newUrlSearchParams.get('video_mode');
        let booleanValue = false;
        if (video_mode === 'true') {
          booleanValue = true;
        }
        this.product.isVideo       = booleanValue;
        this.product.isVideoEditor = booleanValue;
      }
      this.$store.commit('activeProduct/updateIsVideoMoodOn', this.product.isVideo);
      this.$store.commit('activeProduct/updateIsVideoEditor', this.product.isVideoEditor);
      this.product.pages              = pages;
      this.product.scaleX             = 1;
      this.product.scaleY             = 1;
      this.product.isShowCrop         = json.AllowCropping;
      this.product.isAlignmentGuideOn = false;
      this.defaultProductWidth        = parseInt(this.getProductSizePixel.width);
      this.defaultProductHeight       = parseInt(this.getProductSizePixel.height);
      this.defaultProductName         = this.getProductName;
      isOldOrder && (delete this.product.DesignJson);
      this.addObjectForUndoRedo();
      // const { AllowCropping, XCrop, YCrop, WidthCrop, HeightCrop } = this.product;
      // this.$store.commit('setDefaultCropMarks',{ AllowCropping, XCrop, YCrop, WidthCrop, HeightCrop } );
      // Load Color Before product Parse
      this.renderProductFontIntoDom(productXML);
      setTimeout(() => {
        this.loadPmsColorNewInfo(this.product, productXML);
      }, 0);

      // Adding property in product that are receive empty
    },
    addObjectForUndoRedo() {
      this.product.pages.forEach((page, i) => {
        const object = {
          animation: page.animation,
          name:      'none',
          type:      'pagedetails',
        };
        // this.product.pages[i].objectList.push(object);
      });
    },
    renderProductFontIntoDom(productXML) {
      const textFields = productXML.getElementsByTagName('TextField');
      const fontArray  = [];
      for (let textFieldIndex = 0; textFieldIndex < textFields.length; textFieldIndex++) {
        if (textFields[textFieldIndex].getElementsByTagName('Font').length > 0) {
          fontArray.push(textFields[textFieldIndex].getElementsByTagName('Font')[0].innerHTML);
        }
      }

      this.fontFamilyLoad(fontArray);
    },
    async parseProductObject(productXML, product) {
      const textFields = productXML.getElementsByTagName('TextField');
      for (let textFieldIndex = 0; textFieldIndex < textFields.length; textFieldIndex++) {
        let textObject      = new Text();
        textObject          = await textObject.initFromXML(textFields[textFieldIndex]);
        const listPageIndex = textObject.data.PageNo - 1;
        if (listPageIndex > 5 || listPageIndex > product.pages.length) { continue; }
        let listObjectIndex                                                   = product.pages[listPageIndex].objectList.push(textObject.data);
        listObjectIndex                                                      -= 1;
        product.pages[listPageIndex].objectList[listObjectIndex].elementIndex = listObjectIndex;
        product.pages[listPageIndex].objectList[listObjectIndex].PageNo       = listPageIndex;
      }

      const imagesFields = productXML.getElementsByTagName('ImageField');
      for (let imageFieldIndex = 0; imageFieldIndex < imagesFields.length; imageFieldIndex++) {
        let imageField      = new Image();
        imageField          = await imageField.initFromXML(imagesFields[imageFieldIndex]);
        const listPageIndex = imageField.data.PageNo - 1;
        if (listPageIndex > 5 || listPageIndex > product.pages.length) { continue; }
        let listObjectIndex                                                   = product.pages[listPageIndex].objectList.push(imageField.data);
        listObjectIndex                                                      -= 1;
        product.pages[listPageIndex].objectList[listObjectIndex].elementIndex = listObjectIndex;
      }
      const backgroundFields = productXML.getElementsByTagName('BackgroundField');
      for (let backgroundFieldIndex = 0; backgroundFieldIndex < backgroundFields.length; backgroundFieldIndex++) {
        let backgroundField = new Background();
        backgroundField     = await backgroundField.initFromXML(backgroundFields[backgroundFieldIndex]);
        const listPageIndex = backgroundField.data.PageNo - 1;
        if (listPageIndex > 5 || listPageIndex > product.pages.length) { continue; }
        let listObjectIndex                                                   = product.pages[listPageIndex].objectList.push(backgroundField.data);
        listObjectIndex                                                      -= 1;
        product.pages[listPageIndex].objectList[listObjectIndex].elementIndex = listObjectIndex;
        product.pages[listPageIndex].objectList[listObjectIndex].PageNo       = listPageIndex;
      }
    },
    parseProductProperties(productXML, product) {
      const YCrop        = productXML.getElementsByTagName('YCrop')[0];
      this.product.YCrop = YCrop.innerHTML ? YCrop.innerHTML : 0;

      const XCrop        = productXML.getElementsByTagName('XCrop')[0];
      this.product.XCrop = XCrop.innerHTML ? XCrop.innerHTML : 0;


      const PageHeights               = productXML.getElementsByTagName('PageHeights');
      let temp                        = PageHeights[0].children[0].textContent ? Number(PageHeights[0].children[0].textContent) : 0;
      this.product.PageHeights        = {};
      this.product.PageHeights.double = temp;
      const PageWidths                = productXML.getElementsByTagName('PageWidths');
      temp                            = PageWidths[0].children[0].textContent ? Number(PageWidths[0].children[0].textContent) : 0;
      this.product.PageWidths         = {};
      this.product.PageWidths.double  = temp;

      const WidthCrop        = productXML.getElementsByTagName('WidthCrop')[0];
      this.product.WidthCrop = WidthCrop.innerHTML ? Number(WidthCrop.innerHTML) : this.product.PageWidths.double;

      const HeightCrop        = productXML.getElementsByTagName('HeightCrop')[0];
      this.product.HeightCrop = HeightCrop.innerHTML ? Number(HeightCrop.innerHTML) : this.product.PageHeights.double;

      const CsvFilePath        = productXML.getElementsByTagName('CsvFilePath')[0];
      this.product.CsvFilePath = CsvFilePath.innerHTML ? CsvFilePath.innerHTML : null;

      const TriviaQuestions        = productXML.getElementsByTagName('TriviaQuestions')[0];
      this.product.TriviaQuestions = TriviaQuestions.innerHTML ? TriviaQuestions.innerHTML : null;

      delete this.product.Backgrounds; // this field contain xml so no need to keep in new editor.
      delete this.product.Fields;
      delete this.product.Images;

      //   this.$store.commit('setProductPages', pages);
      //  this.selectedPage = pages[0];

      // if (this.product.Id === '1805d69d-59ba-486b-80de-63137d8f46f7') {
      this.replaceResourcesWithHighResolutionResourceInProduct().then(async () => {
        await setTimeout(() => {
          this.updateProductColorList();
          this.$nextTick(() => {
            this.$store.commit('updateSelectedProduct', _.cloneDeep(this.product));
          });
        }, 3000);
      });
      // this.initiatePageWiseUndoRedoArray();
      this.loadAllAddressBoxes(this.product.Id);
      this.loadFontsByBank(this.product.Id);
      this.productPagesLength = this.product.pages.length;
      this.sortContentListArray();
      // wait from replace High Resolution resources
      setTimeout(() => {
        this.initiatePageWiseUndoRedoArray();

        // this.onAddIntoPageWiseUndoRedoArray('called by load canvas');
      }, 2000);
    },
    extractProductBaseImages(baseURLString) {
      return baseURLString.includes('\n') && baseURLString.split('\n');
    },
    async updateProductColorList() {
      EventBus.$emit('StartProductColorProcessing');
      const colorList = await this.extractColorFromProduct();
      setTimeout(() => {
        colorList.length && (this.$store.commit('updateProductColor', _.cloneDeep(colorList)));
        EventBus.$emit('StopProductColorProcessing');
      }, 2000);
    },
    async loadProductFromJson({ orderJson, orderName }) {
      if (!orderJson) {
        return;
      }
      const product = JSON.parse(orderJson);
      product.pages.forEach((page, index) => {
        if (!page.animation) {
          product.pages[index].animation = {
            speed:         1,
            style:         'pageAnimationNone',
            startTime:     0.0,
            duration:      5.0,
            onEnter:       false,
            onExit:        false,
            timeLineWidth: 140,
          };
        }
      });
      this.product      = await this.decodeTextSvgAndCroppedImageComponents(product);
      this.product.Name = orderName;
      this.activePage   = 0;
      this.replaceResourcesWithHighResolutionResourceInProduct().then(async () => {
        await setTimeout(() => {
          this.updateProductColorList();
        }, 3000);
      });

      this.loadAllAddressBoxes(this.product.Id);
      this.loadFontsByBank(this.product.Id);
      try {
        this.loadPmsColorNewInfo(this.product);
      } catch (e) {

      }
      // todo: This check for old order's saved as new.
      if (this.product.DesignJson && this.product.pages.length) {
        const xCrop             = (Number(product.XCrop) * 2);
        const yCrop             = (Number(product.YCrop) * 2);
        const { width, height } = this.product.pages[0];
        const isChangeWidthCrop = (this.product.WidthCrop + xCrop) != width;
        isChangeWidthCrop && (this.product.WidthCrop = width - xCrop);
        const isChangeHeightCrop = (this.product.HeightCrop + yCrop) != height;
        isChangeHeightCrop && (this.product.HeightCrop = height - yCrop);
      }
      if (this.product) {
        const isVideoMoodOn = this.$store.getters['activeProduct/getIsVideoMoodOn'];
        const isVideoEditor = this.$store.getters['activeProduct/getIsVideoEditor'];

        this.product.isVideo       = this.product.isVideo || isVideoMoodOn || false;
        this.product.isVideoEditor = this.product.isVideoEditor || isVideoEditor || false;

        this.$store.commit('activeProduct/updateIsVideoMoodOn', this.product.isVideo);
        this.$store.commit('activeProduct/updateIsVideoEditor', this.product.isVideoEditor);
      }
      this.productPagesLength   = this.product.pages.length;
      this.defaultProductWidth  = parseInt(this.getProductSizePixel.width);
      this.defaultProductHeight = parseInt(this.getProductSizePixel.height);
      setTimeout(() => {
        this.initiatePageWiseUndoRedoArray();
        this.$nextTick(() => {
          this.$store.commit('updateSelectedProduct', _.cloneDeep(this.product));
        });
      }, 2000);
    },
    decodeTextSvgAndCroppedImageComponents(product) {
      product.Name = decodeURIComponent(product.Name);
      const objectIdList = [];
      product.pages.forEach((page) => {
        page.objectList.forEach((object) => {
          if (objectIdList.indexOf(object.Id) > -1) {
            object.Id = uuidv4();
          }
          objectIdList.push(object.Id);
          object.type == 'text' && (object.Value = decodeURIComponent(object.Value));
          object.type == 'text' && (object.modifiedHtml = object.Value);
          if (object.type == 'image' && object.ImageType == 'SVGImage') {
            object.SvgProperty.content = decodeURIComponent(object.SvgProperty.content);
          }
          if (object.type == 'image' && object.croppedSrc != 'none') {
            object.DefaultImageUrl    = decodeURIComponent(object.DefaultImageUrl);
            object.croppedSrc         = decodeURIComponent(object.croppedSrc);
            object.HighResPath        = decodeURIComponent(object.HighResPath);
            object.croppedHighResPath = decodeURIComponent(object.croppedHighResPath);
          }
          if (object.type == 'image' && object.AlternativeImageUrlsResVersion) {
            object.AlternativeImageUrlsResVersion.forEach((cur) => {
              if (cur.ImageThumbnailPath && cur.ImageThumbnailPathV2) {
                cur.ImageThumbnailPath   = decodeURIComponent(cur.ImageThumbnailPath);
                cur.ImageThumbnailPathV2 = decodeURIComponent(cur.ImageThumbnailPathV2);
              }
            });
          }
          if (object.type === 'text') {
            if (!object.textShadow) {
              object.textShadow = {
                textEffect: 'none',
                angle: 0,
                distance: 0,
                shadowBlur: 0,
                shadowColor: "rgb(252,252,252)",
                transparency: 0,
                shadowOffsetX: 0,
                shadowOffsetY: 0
              };
            }

            if (!object.outLine) {
              object.outLine = {
                textEffect: 'none',
                strokeWidth: 0,
                strokeColor: "#000000"
              };
            }
          }
          if (object.type === 'shape') {
            if (object.isGradient === undefined) {
              object.isGradient = false;
            }

            if (!object.gradient) {
              object.gradient = {
                angle: 0,
                colors: [
                  {
                    id: '1',
                    position: 0,
                    color: 'red',
                    isSelected: true,
                    rgba: 'rgba(255,0,0,1)'
                  },
                  {
                    id: '2',
                    position: 94,
                    color: 'yellow',
                    isSelected: false,
                    rgba: 'rgba(234,239,44,1)'
                  }
                ]
              };
            }
          }

        });
      });
      return product || {};
    },
    async replaceResourcesWithHighResolutionResourceInProduct() {
      await this.product.pages.forEach((page) => {
        page.objectList.forEach((obj) => {
          if (obj.type === 'image') {
            if (obj.hasOwnProperty('HighResPath') && !obj.DefaultImageUrl.trimEnd().endsWith('.svg')) {
              const fileType = obj.HighResPath && obj.HighResPath.substring(obj.HighResPath.lastIndexOf('.') + 1, obj.HighResPath.length);
              if (fileType === 'pdf') {
                const temp_obj = obj;
                axios.post(`https://pdf-processing.bankmarketingcenter.com/node/pdf2svg/pdf2svg?pdf-url=${obj.HighResPath}&productId=${this.product.Id}`)
                  .then((res) => {
                    temp_obj.DefaultImageUrl = res.data.svg;
                    temp_obj.HighResPath     = '';
                  })
                  .catch((e) => {
                    console.error(e);
                    temp_obj.DefaultImageUrl = '';
                  });
              } else {
                (obj.ImageType !== 'Image') && (obj.DefaultImageUrl = obj.HighResPath);
                // obj.DefaultImageUrl = obj.HighResPath
              }
            } else if (obj.DefaultImageUrl.trimEnd().endsWith('.svg') && obj.hasOwnProperty('HighResPath') && obj.HighResPath.trimEnd().endsWith('.pdf')) {
              obj.DefaultImageUrl = `${obj.DefaultImageUrl}?highResImage=${obj.HighResPath}`;
            }
          }
        });
      });
    },
    replaceResources() {
      const allImageElements = document.querySelectorAll('[data-type= "image"]');
      if (allImageElements) {
        for (let i = 0; i < allImageElements.length; i++) {
          this.hardCodedLogicForDemoProduct(allImageElements[i].dataset.elementindex);
          allImageElements[i].firstElementChild.src = this.product.pages[this.getActivePageIndex].objectList[allImageElements[i].dataset.elementindex].srcForPdf;
        }
      }
    },
    hardCodedLogicForDemoProduct(index) {
      const objectIdVsPdfSrc                                                  = {
        'b5222806-aaa0-4082-a56a-909af321f093': '//173.230.137.214/htmlengine/img/fiblogo.svg',
        'e62076cf-7f94-4093-acea-1698fc116bb0': 'http://dev2.wysiwyg.bankmarketingcenter.com/BMCv2/img/fdiclogo.svg',
        'b994abba-961f-4045-ab64-b0c3e65e0116': 'http://dev2.wysiwyg.bankmarketingcenter.com/BMCv2/img/fdictext.svg',
        // 'd7d987a3-c0dd-4de8-8263-aaa8f1cfd9e9': 'http://dev2.wysiwyg.bankmarketingcenter.com/BMCv2/img/ThinkstockPhotos-125917776019.jpg',
        '3ff179d8-37cc-496d-b247-082d346b181a': 'http://dev2.wysiwyg.bankmarketingcenter.com/BMCv2/img/zborder01.svg',
        '5557305c-5b0e-4a71-8ee5-e0d4a0aa7ac1': 'http://dev2.wysiwyg.bankmarketingcenter.com/BMCv2/img/zborder2044.svg',
        'e9ca3fc1-66e3-46b7-91bf-f2f8c4b96674': 'http://dev2.wysiwyg.bankmarketingcenter.com/BMCv2/img/zborder104.svg',
      };
      this.product.pages[this.getActivePageIndex].objectList[index].srcForPdf = objectIdVsPdfSrc[this.product.pages[this.getActivePageIndex].objectList[index].Id];
    },
    /*
                * @Method:loadFonts
                * @param:path
                * @description:loaded fonts in document get from xml and store fonts
                *
                * */
    loadFonts(path) {
      // for time beign get fonts locally
      const xmlParser    = new DOMParser();
      const convertedDoM = xmlParser.parseFromString(this.fontsXml, 'text/xml');
      const fontsResult  = convertedDoM.getElementsByTagName('GetFontsByBankIdResult');
      let jsonFonts      = [];

      if (fontsResult.length > 0) {
        const fonts = fontsResult[0].children;

        for (let ilterFont = 0; ilterFont < fonts.length; ilterFont++) {
          const jsonFontObj = {
            name:        fonts[ilterFont].firstElementChild.innerHTML,
            path:        fonts[ilterFont].lastElementChild.innerHTML,
            id:          '',
            isFavourite: false,
          };
          if (jsonFonts.indexOf(jsonFontObj) === -1) { jsonFonts.push(jsonFontObj); }
        }
        jsonFonts =  [...jsonFonts.reduce((map, obj) => map.set(obj.name, obj), new Map()).values()];
        this.$store.commit('setproductfontarray', jsonFonts);
      }
    },
    getCMYKColor(path) {
      const xmlParser    = new DOMParser();
      const convertedDoM = xmlParser.parseFromString(this.CMYKColor, 'text/xml');
      const pmsColor     = convertedDoM.getElementsByTagName('GetPmsColorNewInfoResult')[0];
      // const newPMSColor    = pmsColor.getElementsByTagName('BankNewPmsColors')[0];
      const allNewPMSColor = pmsColor.getElementsByTagName('AllNewPmsColors')[0];
      const bankId         = pmsColor.getElementsByTagName('BankId')[0];
      const bankName       = pmsColor.getElementsByTagName('BankName')[0];
      const usePmsColor    = allNewPMSColor.getElementsByTagName('PmsColorNew');
      const bankPMSColor   = { bankId, bankName, bankPmsColorList: [] };

      for (let pmsColorIndex = 0; pmsColorIndex < usePmsColor.length; pmsColorIndex++) {
        const pmsColorObj = {
          id:        -1, name:      'white', colorRGB:  '', colorCMYK: '',
        };

        for (const pmsColorObject of usePmsColor[pmsColorIndex].children) {
          switch (pmsColorObject.tagName) {
            case 'Id':
              pmsColorObj.id = pmsColorObject.innerHTML;
              break;
            case 'Name':
              pmsColorObj.name = pmsColorObject.innerHTML;
              break;
            case 'DisplayColorTextRGB':
              pmsColorObj.colorRGB = pmsColorObject.innerHTML;
              break;
            case 'DisplayColorTextCMYK':
              pmsColorObj.colorCMYK = pmsColorObject.innerHTML;
              break;
          }
        }
        bankPMSColor.bankPmsColorList.push(pmsColorObj);
      }
      this.$store.commit('setBankPMSColor', bankPMSColor);
    },
    onObjectAdding(object) {
      object.pageNo = this.activePage;
      this.product.pages[this.activePage].objectList.unshift(object);
      (object.type === 'shape' || object.ImageType == 'WhiteboxLogo' || object.ImageType == 'SVGImage') && EventBus.$emit('updateProductColor');
      this.onUpdateContentListIndexOnLayerSwap(this.product.pages[this.activePage].objectList); // funtion called so that the correct index assingn to the new adding object
      setTimeout(() => {
        this.onAddIntoPageWiseUndoRedoArray('called by on object adding');
      }, 1000);
    },
    changeToggleBulletList(value) {
      const { elementIndex } = this.activeObject;
      const object           = this.product.pages[this.activePage].objectList[elementIndex];
      object.html            = object.editor.getHTML();
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.UPDATED);
    },
    changeToggleNumberList(value) {
      const { elementIndex } = this.activeObject;
      const object           = this.product.pages[this.activePage].objectList[elementIndex];
      object.editor.chain()
        .focus()
        .toggleOrderedList()
        .run();
      object.html = object.editor.getHTML();
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.UPDATED);
    },
    changetoggleSupperScriptList(value) {
      const { elementIndex } = this.activeObject;
      const object           = this.product.pages[this.activePage].objectList[elementIndex];
      !value && object.editor.chain()
        .focus()
        .unsetSubscript()
        .run();
      object.html = object.editor.getHTML();
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.UPDATED);
    },
    changetoggleSubScriptList(value) {
      const { elementIndex } = this.activeObject;
      const object           = this.product.pages[this.activePage].objectList[elementIndex];
      !value && object.editor.chain()
        .focus()
        .unsetSuperscript()
        .run();
      object.html = object.editor.getHTML();
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.UPDATED);
    },
    onReceivePushedValue(receivedObject) {
      this.product.pages[this.activePage].objectList.push(receivedObject);
    },
  },
};
</script>
<style lang="scss" scoped>
.flex-left-panel {
  flex: 0 0 344px;
  width: 344px;
}

.flex-center-panel {
  flex: 1 1 auto;
}

.flex-right-panel {
  flex: 0 0 256px;
  height: auto;

}

.loader-styling {
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.79);
}

.loader {
  height: 256px;
  width: 256px;
  margin-bottom: 25px
}
.set-z-index{
  z-index: 100000;
}
</style>
